(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
(function () {
  /* Copy-link button */
  document.querySelectorAll('.art-share__copy').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.url || window.location.href;
      navigator.clipboard && navigator.clipboard.writeText(url).then(function () {
        btn.classList.add('copied');
        var icon = btn.querySelector('i');
        if (icon) { icon.className = 'fa-solid fa-check'; }
        setTimeout(function () {
          btn.classList.remove('copied');
          if (icon) { icon.className = 'fa-solid fa-link'; }
        }, 2000);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-rugs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.fr-showcase').forEach(function (root) {
    var slides    = Array.from(root.querySelectorAll('.fr-slide'));
    var bgGroups  = Array.from(root.querySelectorAll('.fr-bg-group'));
    var prevBtn   = root.querySelector('[data-fr-action="prev"]');
    var nextBtn   = root.querySelector('[data-fr-action="next"]');
    var total     = slides.length;
    var current   = 0;

    if (!total) return;

    /* ── Rug navigation ── */
    function goTo(idx) {
      idx = ((idx % total) + total) % total;
      if (idx === current) return;

      var prev = current;
      current  = idx;

      slides[prev].classList.add('is-exit');
      slides[prev].classList.remove('is-active');
      bgGroups[prev] && bgGroups[prev].classList.remove('is-active');

      var exiting = slides[prev];
      setTimeout(function () { exiting.classList.remove('is-exit'); }, 420);

      slides[current].classList.add('is-active');
      bgGroups[current] && bgGroups[current].classList.add('is-active');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* ── Keyboard navigation ── */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    /* ── Swipe support ── */
    var tx0 = 0;
    root.addEventListener('touchstart', function (e) {
      tx0 = e.changedTouches[0].screenX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - tx0;
      if (Math.abs(dx) < 44) return;
      goTo(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });

    /* ── BG thumbnail switching (per bg-group) ── */
    bgGroups.forEach(function (group) {
      var thumbs   = Array.from(group.querySelectorAll('.fr-thumb'));
      var bgSlides = Array.from(group.querySelectorAll('.fr-bg-slide'));
      var curBg    = 0;

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          if (i === curBg) return;

          bgSlides[curBg] && bgSlides[curBg].classList.remove('is-active');
          thumbs[curBg]   && thumbs[curBg].classList.remove('is-active');
          thumbs[curBg]   && thumbs[curBg].setAttribute('aria-pressed', 'false');

          curBg = i;

          bgSlides[curBg] && bgSlides[curBg].classList.add('is-active');
          thumbs[curBg]   && thumbs[curBg].classList.add('is-active');
          thumbs[curBg]   && thumbs[curBg].setAttribute('aria-pressed', 'true');
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  /* ---- Favourites button state ---- */
  function updateFavBtn() {
    var fav = window.NileFavourites;
    var btn = document.getElementById('fav-btn');
    if (!fav || !btn) return;
    btn.classList.toggle('has-favs', fav.getAll().length > 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFavBtn);
  } else {
    updateFavBtn();
  }
  document.addEventListener('nile:fav-changed', updateFavBtn);
})();

(function () {
  /* ---- Topbar panel ---- */
  var bar   = document.getElementById('topbar-bar');
  var panel = document.getElementById('topbar-panel');
  if (!bar || !panel) return;

  var backdrop = panel.querySelector('.tbp__backdrop');

  /* When the promo row is enabled it stacks below the ticker (both mobile
     and desktop), making the bar taller than the CSS-assumed single-row
     height — sync body padding so page content isn't hidden underneath. */
  function syncTopbarHeight() {
    document.body.style.paddingTop = bar.classList.contains('top-bar--split')
      ? bar.offsetHeight + 'px'
      : '';
  }
  syncTopbarHeight();
  window.addEventListener('resize', syncTopbarHeight);

  function openPanel() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    bar.setAttribute('aria-expanded', 'true');
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    bar.setAttribute('aria-expanded', 'false');
    bar.focus();
  }

  function togglePanel() {
    if (panel.classList.contains('is-open')) {
      closePanel();
    } else {
      openPanel();
    }
  }

  bar.addEventListener('click', togglePanel);
  bar.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      togglePanel();
    }
  });

  backdrop && backdrop.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      closePanel();
    }
  });
})();

(function () {
  /* ---- Top-bar ticker: single-item rotator, driven by setInterval rather
     than a pure CSS animation-delay chain. A CSS animation keeps advancing
     on wall-clock time even while a tab is backgrounded/throttled, so when
     it resumes each item jumps independently to whatever keyframe % elapsed
     time landed on — sometimes showing two items at once or none instead of
     a clean crossfade. Resetting the interval on visibilitychange avoids that. */
  var ticker = document.querySelector('.top-bar__ticker');
  var bar    = document.getElementById('topbar-bar');
  if (!ticker) return;

  var items = Array.prototype.slice.call(ticker.querySelectorAll('.top-bar__item'));
  if (items.length < 2) return;

  var current = 0;
  var timer   = null;

  function show(index) {
    items.forEach(function (item, i) {
      if (i === index) {
        item.classList.remove('is-leaving');
        item.classList.add('is-active');
      } else if (item.classList.contains('is-active')) {
        item.classList.remove('is-active');
        item.classList.add('is-leaving');
        window.setTimeout(function () {
          item.classList.remove('is-leaving');
        }, 950);
      }
    });
  }

  function advance() {
    if (bar && bar.getAttribute('aria-expanded') === 'true') return;
    current = (current + 1) % items.length;
    show(current);
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();
    timer = window.setInterval(advance, 3000);
  }

  show(current);
  start();

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });
})();

(function () {
  /* ---- Country selector (desktop top bar + mobile nav drawer) ---- */
  function initCountrySelect(wrapId, btnId, menuId) {
    var wrap = document.getElementById(wrapId);
    var btn  = document.getElementById(btnId);
    var menu = document.getElementById(menuId);
    if (!wrap || !btn || !menu) return;

    function openMenu() {
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (wrap.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    btn.addEventListener('keydown', function (e) {
      e.stopPropagation();
    });

    menu.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  initCountrySelect('country-select', 'country-select-btn', 'country-select-menu');
  initCountrySelect('country-select-mobile', 'country-select-mobile-btn', 'country-select-mobile-menu');
})();

(function () {
  /* ---- Mobile nav drawer (drill-down, unlimited levels) ---- */
  var toggle   = document.getElementById('nav-toggle');
  var closeBtn = document.getElementById('nav-close');
  var drawer   = document.getElementById('site-nav-mobile');
  if (!toggle || !drawer) return;

  var backdrop    = drawer.querySelector('.snm__backdrop');
  var rootLevel   = drawer.querySelector('.snm__level--root');
  var levelStack  = [];

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    toggle.focus();
    if (levelStack.length > 0) { resetToRoot(); }
  }

  function currentLevel() {
    return levelStack.length > 0 ? levelStack[levelStack.length - 1] : rootLevel;
  }

  function drillIn(targetId) {
    var target = document.getElementById(targetId);
    if (!target) return;
    currentLevel().classList.add('is-exiting');
    target.classList.add('is-active');
    target.setAttribute('aria-hidden', 'false');
    levelStack.push(target);
  }

  function drillOut() {
    if (levelStack.length === 0) return;
    var leaving = levelStack.pop();
    leaving.classList.remove('is-active');
    leaving.setAttribute('aria-hidden', 'true');
    currentLevel().classList.remove('is-exiting');
  }

  function resetToRoot() {
    while (levelStack.length > 0) {
      var lvl = levelStack.pop();
      lvl.classList.remove('is-active', 'is-exiting');
      lvl.setAttribute('aria-hidden', 'true');
    }
    rootLevel.classList.remove('is-exiting');
  }

  toggle.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  backdrop && backdrop.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', function (e) {
    var parentBtn = e.target.closest('.snm__link--parent');
    if (parentBtn) { drillIn(parentBtn.dataset.target); return; }
    var backBtn = e.target.closest('.snm__back');
    if (backBtn) { drillOut(); return; }
    var accordionBtn = e.target.closest('.snm__accordion-row-toggle');
    if (accordionBtn) {
      var expanded = accordionBtn.getAttribute('aria-expanded') === 'true';
      accordionBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var body = accordionBtn.closest('.snm__list-item').querySelector('.snm__accordion-body');
      if (body) body.classList.toggle('is-collapsed', expanded);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      levelStack.length > 0 ? drillOut() : closeDrawer();
    }
  });
})();

(function () {
  /* ---- Search Overlay with Predictive Search ---- */
  var overlay   = document.getElementById('srch-overlay');
  var input     = document.getElementById('srch-input');
  var clearBtn  = document.getElementById('srch-clear');
  var closeBtn  = document.getElementById('srch-close');
  var resultsEl = document.getElementById('srch-results');
  var searchBtns = document.querySelectorAll('.site-header__search-btn');
  if (!overlay || !input || !searchBtns.length) return;

  var backdrop     = overlay.querySelector('.srch-overlay__backdrop');
  var overlayForm  = overlay.querySelector('.srch-overlay__form');
  var debounceTimer;
  var activeQuery  = '';
  var moneyFormat  = overlay.dataset.moneyFormat || '$ {{ amount }}';

  /* Blocked-term guard: Shopify's Search & Discovery app auto-synonyms
     "iran" to "persian" server-side, so we stop the query before it ever
     reaches Shopify's endpoint. Case-insensitive, matches anywhere in the
     query. Mirrors the same guard in sections/search.liquid. */
  var BLOCKED_TERMS = ['iran', 'persia']; // 'persia' is a stem — also catches persian/persians
  function isBlockedQuery(q) {
    var lower = (q || '').toLowerCase();
    return BLOCKED_TERMS.some(function (term) { return lower.indexOf(term) !== -1; });
  }
  function showBlockedMessage(q) {
    resultsEl.className = 'srch-overlay__results';
    resultsEl.innerHTML = '<p class="srch-results__no-results">No results for <strong>' + esc(q) + '</strong>.</p>';
  }

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var visibleBtn = Array.prototype.find.call(searchBtns, function(b) { return b.offsetParent !== null; });
    if (visibleBtn) visibleBtn.focus();
  }

  searchBtns.forEach(function(btn) { btn.addEventListener('click', openSearch); });
  closeBtn  && closeBtn.addEventListener('click', closeSearch);
  backdrop  && backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  clearBtn && clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    resultsEl.innerHTML = '';
    resultsEl.className = 'srch-overlay__results';
    input.focus();
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = !q;
    clearTimeout(debounceTimer);
    if (!q) {
      resultsEl.innerHTML = '';
      resultsEl.className = 'srch-overlay__results';
      return;
    }
    if (isBlockedQuery(q)) {
      activeQuery = q;
      showBlockedMessage(q);
      return;
    }
    resultsEl.innerHTML = '';
    resultsEl.className = 'srch-overlay__results srch-overlay__results--loading';
    debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 280);
  });

  overlayForm && overlayForm.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (isBlockedQuery(q)) {
      e.preventDefault();
      showBlockedMessage(q);
    }
  });

  function fetchSuggestions(q) {
    if (isBlockedQuery(q)) { activeQuery = q; showBlockedMessage(q); return; }
    activeQuery = q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=5'
      + '&resources[options][fields]=title,body,product_type,vendor,tag,variants.title,variants.sku,variants.barcode';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (activeQuery !== q) return;
        resultsEl.className = 'srch-overlay__results';
        renderResults(data, q);
      })
      .catch(function () {
        resultsEl.className = 'srch-overlay__results';
      });
  }

  function formatMoney(price) {
    var n = parseFloat(price);
    var amount = n % 1 === 0
      ? String(Math.round(n)).replace(/\d(?=(\d{3})+$)/g, '$&,')
      : n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function esc(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderResults(data, q) {
    var res = data.resources && data.resources.results;
    if (!res) { resultsEl.innerHTML = '<p class="srch-results__no-results">No results found.</p>'; return; }

    var products = res.products || [];
    var html     = '';

    if (products.length) {
      html += '<p class="srch-results__group-title">Products</p><ul class="srch-results__list">';
      products.forEach(function (p) {
        var img = p.featured_image
          ? '<img class="srch-results__img" src="' + esc(p.featured_image.url) + '" alt="' + esc(p.title) + '" width="48" height="48" loading="lazy">'
          : '<div class="srch-results__img-placeholder"></div>';
        var price = p.price ? '<p class="srch-results__price">' + formatMoney(p.price) + '</p>' : '';
        html += '<li class="srch-results__item"><a href="' + esc(p.url) + '">'
          + img + '<div class="srch-results__info"><p class="srch-results__title">' + esc(p.title) + '</p>' + price + '</div></a></li>';
      });
      html += '</ul>';
    }

    if (products.length === 0) {
      html = '<p class="srch-results__no-results">No results for <strong>' + esc(q) + '</strong>.</p>';
    } else {
      html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bfields%5D=title%2Cbody%2Cproduct_type%2Cvendor%2Ctag%2Cvariants.title%2Cvariants.sku%2Cvariants.barcode" class="srch-results__view-all">View all results &rarr;</a>';
    }

    resultsEl.innerHTML = html;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  function wireFeaturedWishlist() {
    var fav = window.NileFavourites;
    if (!fav) return;
    var buttons = document.querySelectorAll('.nr-fp__wish[data-fav-id]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.favWired) return;
      btn.dataset.favWired = '1';
      function setState(active) {
        var icon = btn.querySelector('i');
        if (active) {
          btn.classList.add('nr-fp__wish--active');
          btn.setAttribute('aria-label', 'Remove from favourites');
          if (icon) icon.className = 'fa-solid fa-heart';
        } else {
          btn.classList.remove('nr-fp__wish--active');
          btn.setAttribute('aria-label', 'Add to favourites');
          if (icon) icon.className = 'fa-regular fa-heart';
        }
      }
      setState(fav.has(btn.dataset.favId));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var product = {
          id:    btn.dataset.favId,
          title: btn.dataset.favTitle,
          url:   btn.dataset.favUrl,
          image: btn.dataset.favImage,
          price: btn.dataset.favPrice
        };
        var added = fav.toggle(product);
        setState(added);
        if (added) {
          var rect  = btn.getBoundingClientRect();
          var heart = document.createElement('span');
          heart.className = 'prd-floating-heart';
          heart.setAttribute('aria-hidden', 'true');
          heart.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
          heart.style.left = (rect.left + rect.width / 2 - 11) + 'px';
          heart.style.top  = (rect.top - 4) + 'px';
          document.body.appendChild(heart);
          heart.addEventListener('animationend', function () { heart.remove(); });
        }
      });
    });
  }
  if (window.NileFavourites) {
    wireFeaturedWishlist();
  } else {
    document.addEventListener('nile:fav-ready', wireFeaturedWishlist, { once: true });
    window.addEventListener('load', wireFeaturedWishlist);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
/* Size the mobile hero to the real visible viewport (behind the fixed
   top-bar/header), so the image panel can flex to fill exactly whatever
   space is left above the CTA instead of using a guessed fixed height —
   the banner fills the full screen on tall devices and shrinks on short
   ones, but the CTA never ends up below the fold. */
(function () {
  'use strict';
  var hero = document.querySelector('.nr-hero');
  if (!hero) return;
  var mq = window.matchMedia('(max-width: 900px)');

  /* Runs on desktop too — the full-bleed banner uses the same
     variable to fill exactly the visible screen below the header. */
  function setAvailHeight() {
    var viewportH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var chromeH = hero.getBoundingClientRect().top + window.scrollY;
    hero.style.setProperty('--nr-hero-top', chromeH + 'px');
    var avail = viewportH - chromeH;
    if (avail > 0) {
      hero.style.setProperty('--nr-hero-avail', avail + 'px');
    }
  }

  setAvailHeight();
  window.addEventListener('load', setAvailHeight);
  window.addEventListener('resize', setAvailHeight);
  window.addEventListener('orientationchange', setAvailHeight);
  if (mq.addEventListener) {
    mq.addEventListener('change', setAvailHeight);
  }
})();

/* IntersectionObserver for scroll-animated sections */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-nr-animate]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('nr-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.dataset.nrDelay || '0', 10);
      setTimeout(function () { el.classList.add('nr-visible'); }, delay);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -60px 0px', threshold: 0.12 });
  els.forEach(function (el) { io.observe(el); });
})();

/* Trust bar: single-item rotator on mobile only (mirrors the header
   announcement-bar ticker) — driven by setInterval so it stays a clean
   crossfade even if the tab was backgrounded/throttled. */
(function () {
  'use strict';
  var row = document.querySelector('.nr-hero-tb__row');
  if (!row) return;
  var items = Array.prototype.slice.call(row.querySelectorAll('.nr-hero-tb__item'));
  if (items.length < 2) return;

  var mq = window.matchMedia('(max-width: 900px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;
  var timer = null;

  function show(index) {
    items.forEach(function (item, i) {
      if (i === index) {
        item.classList.remove('is-leaving');
        item.classList.add('is-active');
      } else if (item.classList.contains('is-active')) {
        item.classList.remove('is-active');
        item.classList.add('is-leaving');
        window.setTimeout(function () { item.classList.remove('is-leaving'); }, 950);
      }
    });
  }

  function advance() {
    current = (current + 1) % items.length;
    show(current);
  }

  function stop() {
    if (timer) { window.clearInterval(timer); timer = null; }
  }

  function start() {
    if (!mq.matches || reduceMotion) return;
    stop();
    timer = window.setInterval(advance, 3000);
  }

  start();
  if (mq.addEventListener) {
    mq.addEventListener('change', function () { mq.matches ? start() : stop(); });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stop(); } else { start(); }
  });
})();

/* Father's Day-style countdown — Days : Hrs : Mins to the configured end date */
(function () {
  'use strict';
  var el = document.querySelector('[data-nr-countdown]');
  if (!el) return;
  var endStr = (el.getAttribute('data-end') || '').trim();
  var end = new Date(endStr.replace(' ', 'T')).getTime();
  if (isNaN(end)) { el.setAttribute('hidden', 'hidden'); return; }

  var daysEl = el.querySelector('[data-unit="days"]');
  var hoursEl = el.querySelector('[data-unit="hours"]');
  var minsEl = el.querySelector('[data-unit="minutes"]');

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var diff = end - Date.now();
    if (diff <= 0) {
      el.setAttribute('hidden', 'hidden');
      window.clearInterval(timer);
      return;
    }
    var totalMinutes = Math.floor(diff / 60000);
    daysEl.textContent = pad(Math.floor(totalMinutes / 1440));
    hoursEl.textContent = pad(Math.floor((totalMinutes % 1440) / 60));
    minsEl.textContent = pad(totalMinutes % 60);
  }

  tick();
  var timer = window.setInterval(tick, 30000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-shop-by-size"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.sbs__grid').forEach(function (track) {
    var bar   = track.closest('.sbs__wrap').querySelector('.sbs__progress-bar');
    var thumb = bar ? bar.querySelector('.sbs__progress-thumb') : null;
    if (!bar || !thumb) return;

    function update() {
      if (track.scrollWidth <= track.clientWidth + 1) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      var ratio    = track.clientWidth / track.scrollWidth;
      var thumbW   = Math.max(ratio * 100, 12);
      var maxLeft  = 100 - thumbW;
      var progress = track.scrollLeft / (track.scrollWidth - track.clientWidth);
      thumb.style.width = thumbW + '%';
      thumb.style.left  = (progress * maxLeft) + '%';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track.scrollLeft = 0;
    update();
    window.addEventListener('load', function () {
      track.scrollLeft = 0;
      update();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }

    function seekFromClientX(clientX) {
      var rect   = bar.getBoundingClientRect();
      var ratio  = track.clientWidth / track.scrollWidth;
      var thumbW = Math.max(ratio, 0.12);
      var usable = 1 - thumbW;
      var frac   = (clientX - rect.left) / rect.width;
      frac = Math.max(0, Math.min(1, frac));
      var progress = (frac - thumbW / 2) / usable;
      progress = Math.max(0, Math.min(1, progress));
      track.scrollLeft = progress * (track.scrollWidth - track.clientWidth);
    }

    bar.addEventListener('click', function (e) {
      if (e.target === thumb) return;
      seekFromClientX(e.clientX);
    });

    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    function onDragStart(e) {
      e.preventDefault();
      dragging = true;
      dragStartX      = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      dragStartScroll = track.scrollLeft;
      thumb.style.transition = 'none';
      document.addEventListener('mousemove', onDragMove);
      document.addEventListener('mouseup',   onDragEnd);
      document.addEventListener('touchmove', onDragMove, { passive: false });
      document.addEventListener('touchend',  onDragEnd);
    }

    function onDragMove(e) {
      if (!dragging) return;
      if (e.cancelable) e.preventDefault();
      var clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      var barW    = bar.getBoundingClientRect().width;
      var ratio   = track.clientWidth / track.scrollWidth;
      var thumbW  = Math.max(ratio, 0.12);
      var usable  = 1 - thumbW;
      var delta   = (clientX - dragStartX) / (barW * usable);
      var newScroll = dragStartScroll + delta * (track.scrollWidth - track.clientWidth);
      track.scrollLeft = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, newScroll));
    }

    function onDragEnd() {
      if (!dragging) return;
      dragging = false;
      thumb.style.transition = '';
      document.removeEventListener('mousemove', onDragMove);
      document.removeEventListener('mouseup',   onDragEnd);
      document.removeEventListener('touchmove', onDragMove);
      document.removeEventListener('touchend',  onDragEnd);
    }

    thumb.addEventListener('mousedown',  onDragStart);
    thumb.addEventListener('touchstart', onDragStart, { passive: false });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-size-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.szf-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var widthInput  = form.querySelector('input[name="width"]');
      var lengthInput = form.querySelector('input[name="length"]');
      var errorEl     = form.querySelector('.szf-card__error');

      var width  = parseFloat(widthInput.value);
      var length = parseFloat(lengthInput.value);
      var hasWidth  = !isNaN(width)  && width  > 0;
      var hasLength = !isNaN(length) && length > 0;

      if (!hasWidth && !hasLength) {
        if (errorEl) errorEl.hidden = false;
        widthInput.focus();
        return;
      }
      if (errorEl) errorEl.hidden = true;

      // Same ±20cm margin as the collection page's own Width/Length filter,
      // so results match whether you search from the home page or refine there.
      var MARGIN = 20;
      var params = [];
      if (hasWidth) {
        params.push('width_min=' + Math.max(0, width - MARGIN));
        params.push('width_max=' + (width + MARGIN));
      }
      if (hasLength) {
        params.push('length_min=' + Math.max(0, length - MARGIN));
        params.push('length_max=' + (length + MARGIN));
      }

      window.location.href = '/collections/all-rugs?' + params.join('&');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accessories"]) return;
  try {
    
(function () {
  'use strict';

  var prdDataEl = document.getElementById('pa-prd-data');
  var prdData   = prdDataEl ? JSON.parse(prdDataEl.textContent) : null;

  function formatMoney(cents) {
    var LB  = '{' + '{';
    var fmt = window.paMoneyFmt || (LB + ' amount }}');
    var amt = cents / 100;
    var str = amt.toFixed(2);
    return fmt
      .replace(LB + ' amount }}', str).replace(LB + 'amount }}', str).replace(LB + 'amount}' + '}', str)
      .replace(LB + ' amount_no_decimals }}', Math.round(amt)).replace(LB + 'amount_no_decimals}}', Math.round(amt))
      .replace(/<[^>]+>/g, '').trim();
  }

  function findVariant(id) {
    if (!prdData) return null;
    return prdData.variants.find(function (v) { return String(v.id) === String(id); }) || null;
  }

  /* ── Collect gallery image data from thumbnails ── */
  var thumbsEl  = document.getElementById('pa-thumbs');
  var thumbBtns = thumbsEl ? Array.from(thumbsEl.querySelectorAll('.pa-thumb')) : [];
  var allImages = thumbBtns.map(function (b) {
    return { src: b.dataset.src, large: b.dataset.large, alt: b.dataset.alt };
  });

  /* Fallback: single image from main img tag */
  if (!allImages.length) {
    var si = document.getElementById('pa-main-img');
    if (si) allImages.push({ src: si.src, large: si.src, alt: si.alt });
  }

  var currentImgIdx  = 0;
  var currentLargeSrc = allImages[0] ? allImages[0].large : '';
  var mainImg = document.getElementById('pa-main-img');

  function setGalleryImg(idx) {
    if (!allImages[idx]) return;
    currentImgIdx   = idx;
    currentLargeSrc = allImages[idx].large;
    if (mainImg) {
      mainImg.src    = allImages[idx].src;
      mainImg.srcset = allImages[idx].src + ' 900w, ' + allImages[idx].large + ' 1400w';
      mainImg.alt    = allImages[idx].alt;
    }
    thumbBtns.forEach(function (b, i) {
      b.classList.toggle('pa-thumb--active', i === idx);
    });
  }

  thumbBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { setGalleryImg(i); });
  });

  /* Thumbnail scroll arrows (up / down) */
  var thumbUp   = document.getElementById('pa-thumb-up');
  var thumbDown = document.getElementById('pa-thumb-down');
  if (thumbUp && thumbsEl) thumbUp.addEventListener('click', function () {
    thumbsEl.scrollBy({ top: -160, behavior: 'smooth' });
  });
  if (thumbDown && thumbsEl) thumbDown.addEventListener('click', function () {
    thumbsEl.scrollBy({ top: 160, behavior: 'smooth' });
  });

  /* ── Lightbox ── */
  var lightbox    = document.getElementById('pa-lightbox');
  var lbImg       = document.getElementById('pa-lb-img');
  var lbClose     = document.getElementById('pa-lb-close');
  var lbBd        = document.getElementById('pa-lb-bd');
  var lbThumbsEl  = document.getElementById('pa-lb-thumbs');
  var lbThumbs    = [];
  var lbIdx       = 0;

  if (lbThumbsEl) {
    allImages.forEach(function (img, i) {
      var t = document.createElement('img');
      t.src = img.src; t.alt = img.alt;
      t.className = 'pa-lb-thumb'; t.tabIndex = 0;
      t.setAttribute('role', 'button');
      t.addEventListener('click', function () { lbSet(i); });
      lbThumbsEl.appendChild(t);
      lbThumbs.push(t);
    });
  }

  function lbSet(i) {
    lbIdx = i;
    if (lbImg) {
      lbImg.classList.add('pa-lb-changing');
      setTimeout(function () {
        lbImg.src = allImages[i].large;
        lbImg.alt = allImages[i].alt;
        lbImg.classList.remove('pa-lb-changing');
      }, 130);
    }
    lbThumbs.forEach(function (t, j) { t.classList.toggle('pa-lb-thumb--active', j === i); });
    if (lbThumbs[i]) lbThumbs[i].scrollIntoView({ inline: 'nearest', behavior: 'smooth' });
  }

  var _lbLastFocus = null;
  function openLightbox(i) {
    if (!lightbox || !allImages.length) return;
    _lbLastFocus = document.activeElement;
    lightbox.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    lbSet(i);
    if (lbClose) lbClose.focus();
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (_lbLastFocus) { _lbLastFocus.focus(); _lbLastFocus = null; }
  }

  var zoomBtn = document.getElementById('pa-zoom-btn');
  if (zoomBtn)  zoomBtn.addEventListener('click', function () { openLightbox(currentImgIdx); });
  if (lbClose)  lbClose.addEventListener('click', closeLightbox);
  if (lbBd)     lbBd.addEventListener('click', closeLightbox);

  var lbPrev = document.getElementById('pa-lb-prev');
  var lbNext = document.getElementById('pa-lb-next');
  if (lbPrev) lbPrev.addEventListener('click', function () { lbSet((lbIdx - 1 + allImages.length) % allImages.length); });
  if (lbNext) lbNext.addEventListener('click', function () { lbSet((lbIdx + 1) % allImages.length); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox || lightbox.hasAttribute('hidden')) return;
    if (e.key === 'Escape')      closeLightbox();
    if (e.key === 'ArrowLeft')   lbSet((lbIdx - 1 + allImages.length) % allImages.length);
    if (e.key === 'ArrowRight')  lbSet((lbIdx + 1) % allImages.length);
  });

  /* ── Variant / size pill selection ── */
  var variantIdInput = document.getElementById('pa-variant-id');
  var priceEl        = document.getElementById('pa-price');
  var compareEl      = document.getElementById('pa-price-compare');
  var atcBtn         = document.getElementById('pa-btn-atc');
  var atcText        = document.getElementById('pa-btn-atc-text');
  var upsellSizeEl   = document.getElementById('pa-upsell-size');
  var sizePills      = Array.from(document.querySelectorAll('.pa-size-pill'));

  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl)  priceEl.textContent = formatMoney(variant.price);
    if (atcBtn)   atcBtn.disabled = !variant.available;
    if (atcText)  atcText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    if (compareEl) {
      var showCmp = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.textContent  = showCmp ? formatMoney(variant.compare_at_price) : '';
      compareEl.style.display = showCmp ? 'inline-block' : 'none';
    }
    if (upsellSizeEl && variant.title !== 'Default Title') {
      upsellSizeEl.textContent = variant.title;
    }
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }
  }

  sizePills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (this.disabled) return;
      sizePills.forEach(function (p) { p.classList.remove('pa-size-pill--active'); p.setAttribute('aria-pressed', 'false'); });
      this.classList.add('pa-size-pill--active');
      this.setAttribute('aria-pressed', 'true');
      var variant = findVariant(this.dataset.variantId);
      if (variant) applyVariant(variant);
    });
  });

  /* ── Quantity ── */
  var qtyInput = document.getElementById('pa-qty-input');
  var qtyMinus = document.getElementById('pa-qty-minus');
  var qtyPlus  = document.getElementById('pa-qty-plus');

  if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', function () {
    var v = parseInt(qtyInput.value, 10) || 1;
    if (v > 1) qtyInput.value = v - 1;
  });
  if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', function () {
    var v = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = v + 1;
  });
  if (qtyInput) qtyInput.addEventListener('change', function () {
    var v = parseInt(this.value, 10);
    if (isNaN(v) || v < 1) this.value = 1;
  });

  /* ── ATC form: adds main product + optional upsell ── */
  (function () {
    var form    = document.getElementById('pa-product-form');
    var upsellChk = document.getElementById('pa-upsell-chk');
    if (!form) return;

    var errEl = document.createElement('p');
    errEl.className = 'pa-atc-error';
    errEl.setAttribute('aria-live', 'polite');
    errEl.hidden = true;
    errEl.style.cssText = 'font-size:13px;color:#b04a2e;margin:-8px 0 14px;';
    if (atcBtn) atcBtn.insertAdjacentElement('afterend', errEl);

    var errTimer = null;
    function showErr(msg) { errEl.textContent = msg; errEl.hidden = false; clearTimeout(errTimer); errTimer = setTimeout(function () { errEl.hidden = true; }, 6000); }
    function hideErr() { clearTimeout(errTimer); errEl.hidden = true; }
    function restoreBtn() {
      if (atcBtn) atcBtn.disabled = false;
      if (atcText) atcText.textContent = 'ADD TO CART';
    }

    function addToCart(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
    }

    function refreshCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { cart: cart } }));
          document.querySelectorAll('.cart-count').forEach(function (b) {
            b.textContent = cart.item_count;
            b.style.display = cart.item_count > 0 ? '' : 'none';
          });
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn && atcBtn.disabled) return;

      var varId = variantIdInput ? variantIdInput.value : null;
      if (!varId) return;

      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      hideErr();
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Adding…';

      var items = [{ id: parseInt(varId, 10), quantity: qty }];
      if (upsellChk && upsellChk.checked && upsellChk.dataset.variantId) {
        items.push({ id: parseInt(upsellChk.dataset.variantId, 10), quantity: 1 });
      }

      addToCart(items)
        .then(function (addedData) {
          if (window.fbq && addedData && addedData.items) {
            var ids = addedData.items.map(function(it){ return String(it.product_id); });
            var val = addedData.items.reduce(function(sum, it){ return sum + it.line_price; }, 0) / 100;
            fbq('track', 'AddToCart', {
              content_ids: ids,
              content_type: 'product',
              value: val,
              currency: '{{ cart.currency.iso_code }}'
            });
          }
          if (window.clarity) { window.clarity('event', 'AddToCart'); }
          refreshCartCount();
          if (atcText) atcText.textContent = 'Added!';
          setTimeout(restoreBtn, 1500);
        })
        .catch(function (err) {
          restoreBtn();
          var isInv = err && (err.status === 422 || (typeof err.description === 'string' && /quantity|stock|inventory/i.test(err.description)));
          if (isInv) showErr('The maximum quantity of this item is already in your cart.');
          else showErr('Something went wrong. Please try again.');
        });
    });
  })();

})();

/* ── Mobile swipe gallery ── */
(function () {
  var mq = window.matchMedia('(max-width: 700px)');
  if (!mq.matches) return;

  var gallery   = document.getElementById('pa-mob-gallery');
  var counterEl = document.getElementById('pa-mob-counter');
  if (!gallery || !counterEl) return;

  var slides = Array.from(gallery.querySelectorAll('.pa-mob-slide'));
  var total  = slides.length;
  if (!total) return;

  slides.forEach(function (s) { var img = s.querySelector('img'); if (img) img.loading = 'eager'; });

  function updateCounter() {
    var w = gallery.clientWidth;
    if (!w) return;
    var idx = Math.min(total - 1, Math.max(0, Math.round(gallery.scrollLeft / w)));
    counterEl.textContent = (idx + 1) + ' / ' + total;
  }

  gallery.addEventListener('scroll', updateCounter, { passive: true });
  requestAnimationFrame(updateCounter);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-v2"]) return;
  try {
    
(function () {
  'use strict';

  /* ── helpers ── */
  var productDataEl = document.getElementById('v2-prd-data');
  var productData   = productDataEl ? JSON.parse(productDataEl.textContent) : null;

  /* `product | json` does not reliably include per-variant inventory fields,
     so those are rendered separately, forcing Liquid to resolve real values. */
  var inventoryDataEl = document.getElementById('v2-prd-inventory');
  var inventoryData   = inventoryDataEl ? JSON.parse(inventoryDataEl.textContent) : {};

  function formatMoney(cents) {
    var LB  = '{' + '{';
    var fmt = window.v2MoneyFmt || (LB + ' amount }}');
    var amt = cents / 100;
    var str = Number.isInteger(amt) ? String(amt) : amt.toFixed(2);
    return fmt
      .replace(LB + ' amount }}', str).replace(LB + 'amount }}', str).replace(LB + 'amount}' + '}', str)
      .replace(LB + ' amount_no_decimals }}', Math.round(amt)).replace(LB + 'amount_no_decimals}}', Math.round(amt))
      .replace(/<[^>]+>/g, '').replace(/\s*AUD\s*/g, '').trim();
  }

  function findVariant(id) {
    if (!productData) return null;
    return productData.variants.find(function (v) { return String(v.id) === String(id); }) || null;
  }

  /* ── Gallery ── */
  var mainImg   = document.getElementById('v2-main-img');
  var thumbsEl  = document.getElementById('v2-thumbs');
  var thumbBtns = thumbsEl ? Array.from(thumbsEl.querySelectorAll('.v2-thumb')) : [];
  var allImages = thumbBtns.map(function (b) {
    return { src: b.dataset.src, large: b.dataset.large, alt: b.dataset.alt };
  });
  var currentImgIdx = 0;
  var currentLargeSrc = allImages[0] ? allImages[0].large : '';
  var counterEl = document.getElementById('v2-img-counter');

  function setGalleryImg(idx) {
    if (!allImages[idx]) return;
    currentImgIdx = idx;
    currentLargeSrc = allImages[idx].large;
    if (mainImg) {
      mainImg.src    = allImages[idx].src;
      mainImg.srcset = allImages[idx].src + ' 900w, ' + allImages[idx].large + ' 1400w';
      mainImg.alt    = allImages[idx].alt;
    }
    thumbBtns.forEach(function (b, i) {
      b.classList.toggle('v2-thumb--active', i === idx);
    });
    if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + allImages.length;
    var sizeEl = document.getElementById('v2-dt-size');
  }

  thumbBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { setGalleryImg(i); });
  });

  /* Thumbnail rail scroll arrows (desktop) — only shown when the rail actually overflows */
  var thumbPrevBtn = document.getElementById('v2-thumb-prev');
  var thumbNextBtn = document.getElementById('v2-thumb-next');
  if (thumbsEl && thumbPrevBtn && thumbNextBtn) {
    var scrollThumbs = function (dir) {
      var step = (thumbBtns[0] ? thumbBtns[0].offsetHeight : 72) + 8;
      thumbsEl.scrollBy({ top: dir * step, behavior: 'smooth' });
    };
    thumbPrevBtn.addEventListener('click', function () { scrollThumbs(-1); });
    thumbNextBtn.addEventListener('click', function () { scrollThumbs(1); });

    var updateThumbArrows = function () {
      var overflows = thumbsEl.scrollHeight > thumbsEl.clientHeight + 1;
      thumbPrevBtn.hidden = !overflows;
      thumbNextBtn.hidden = !overflows;
      if (!overflows) return;
      thumbPrevBtn.disabled = thumbsEl.scrollTop <= 0;
      thumbNextBtn.disabled = thumbsEl.scrollTop + thumbsEl.clientHeight >= thumbsEl.scrollHeight - 1;
    };
    thumbsEl.addEventListener('scroll', updateThumbArrows, { passive: true });
    window.addEventListener('resize', updateThumbArrows);
    updateThumbArrows();
  }

  /* Main image nav arrows */
  var navPrev = document.getElementById('v2-nav-prev');
  var navNext = document.getElementById('v2-nav-next');
  if (navPrev) navPrev.addEventListener('click', function () {
    setGalleryImg((currentImgIdx - 1 + allImages.length) % allImages.length);
  });
  if (navNext) navNext.addEventListener('click', function () {
    setGalleryImg((currentImgIdx + 1) % allImages.length);
  });

  /* ── Zoom popup ── */
  (function () {
    var popup = document.getElementById('v2-zoom-popup');
    var ind   = document.getElementById('v2-zoom-ind');
    if (!popup || !mainImg) return;

    var ZOOM     = 3;
    var POP_SIZE = 440;
    var IND_HALF = (POP_SIZE / ZOOM) / 2;

    var wrap = document.getElementById('v2-main-wrap');

    mainImg.addEventListener('mousemove', function (e) {
      var rect  = mainImg.getBoundingClientRect();
      var rawX  = e.clientX - rect.left;
      var rawY  = e.clientY - rect.top;

      /* object-fit:contain can create transparent side/top strips —
         calculate the actual rendered content box */
      var nw    = mainImg.naturalWidth  || rect.width;
      var nh    = mainImg.naturalHeight || rect.height;
      var scale = Math.min(rect.width / nw, rect.height / nh);
      var cW    = nw * scale;
      var cH    = nh * scale;
      var offX  = (rect.width  - cW) / 2;
      var offY  = (rect.height - cH) / 2;

      var x = rawX - offX;
      var y = rawY - offY;

      /* cursor is in the letterbox area — hide and bail */
      if (x < 0 || y < 0 || x > cW || y > cH) {
        popup.style.display = 'none';
        if (ind) ind.style.display = 'none';
        return;
      }

      /* position indicator relative to the wrapper div */
      if (ind && wrap) {
        var wRect = wrap.getBoundingClientRect();
        ind.style.display = 'block';
        ind.style.width   = (IND_HALF * 2) + 'px';
        ind.style.height  = (IND_HALF * 2) + 'px';
        ind.style.left    = (rect.left - wRect.left + offX + x - IND_HALF) + 'px';
        ind.style.top     = (rect.top  - wRect.top  + offY + y - IND_HALF) + 'px';
      }

      popup.style.display            = 'block';
      popup.style.backgroundImage    = 'url(' + (currentLargeSrc || mainImg.src) + ')';
      popup.style.backgroundSize     = (cW * ZOOM) + 'px ' + (cH * ZOOM) + 'px';
      popup.style.backgroundPosition = (-(x - IND_HALF) * ZOOM) + 'px ' + (-(y - IND_HALF) * ZOOM) + 'px';
    });

    mainImg.addEventListener('mouseleave', function () {
      popup.style.display = 'none';
      if (ind) ind.style.display = 'none';
    });
  })();

  /* ── Lightbox ── */
  var lightbox   = document.getElementById('v2-lightbox');
  var lbImg      = document.getElementById('v2-lb-img');
  var lbClose    = document.getElementById('v2-lb-close');
  var lbBd       = document.getElementById('v2-lb-bd');
  var lbThumbsEl = document.getElementById('v2-lb-thumbs');
  var lbThumbs   = [];
  var lbIdx      = 0;

  /* Build lightbox thumbnails */
  if (lbThumbsEl) {
    allImages.forEach(function (img, i) {
      var t = document.createElement('img');
      t.src = img.src; t.alt = img.alt;
      t.className = 'v2-lb-thumb'; t.tabIndex = 0;
      t.setAttribute('role', 'button');
      t.addEventListener('click', function () { lbSetActive(i); });
      lbThumbsEl.appendChild(t);
      lbThumbs.push(t);
    });
  }

  function lbSetActive(i) {
    lbIdx = i;
    if (lbImg) {
      lbImg.classList.add('v2-lb-changing');
      setTimeout(function () {
        lbImg.src = allImages[i].large;
        lbImg.alt = allImages[i].alt;
        lbImg.classList.remove('v2-lb-changing');
      }, 130);
    }
    lbThumbs.forEach(function (t, j) { t.classList.toggle('v2-lb-thumb--active', j === i); });
    if (lbThumbs[i]) lbThumbs[i].scrollIntoView({ inline: 'nearest', behavior: 'smooth' });
  }

  var _lbLastFocus = null;
  function openLightbox(i) {
    if (!lightbox || allImages.length === 0) return;
    _lbLastFocus = document.activeElement;
    lightbox.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    lbSetActive(i);
    if (lbClose) lbClose.focus();
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (_lbLastFocus) { _lbLastFocus.focus(); _lbLastFocus = null; }
  }

  var zoomBtn = document.getElementById('v2-zoom-btn');
  if (zoomBtn) zoomBtn.addEventListener('click', function () { openLightbox(currentImgIdx); });
  if (mainImg) mainImg.addEventListener('click', function () { openLightbox(currentImgIdx); });
  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbBd)    lbBd.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', function (e) {
    if (!lightbox || lightbox.hasAttribute('hidden')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft')  lbSetActive((lbIdx - 1 + allImages.length) % allImages.length);
    if (e.key === 'ArrowRight') lbSetActive((lbIdx + 1) % allImages.length);
  });

  var lbPrev = document.getElementById('v2-lb-prev');
  var lbNext = document.getElementById('v2-lb-next');
  if (lbPrev) lbPrev.addEventListener('click', function () { lbSetActive((lbIdx - 1 + allImages.length) % allImages.length); });
  if (lbNext) lbNext.addEventListener('click', function () { lbSetActive((lbIdx + 1) % allImages.length); });

  /* ── Variant update ── */
  var variantIdInput = document.getElementById('v2-variant-id');
  var priceEl        = document.getElementById('v2-price');
  var compareEl      = document.getElementById('v2-price-compare');
  var badgeEl        = document.getElementById('v2-price-badge');
  var bfChipEl       = document.getElementById('v2-bf-chip');
  var saveAmtEl      = document.getElementById('v2-price-save-amt');
  var savePctEl      = document.getElementById('v2-price-save-pct');
  var stockEl        = document.getElementById('v2-price-stock');
  var atcBtn         = document.getElementById('v2-btn-atc');
  var atcText        = document.getElementById('v2-btn-atc-text');
  var attrSizeEl     = document.getElementById('v2-attr-size');
  var dtSkuEl        = document.getElementById('v2-dt-sku');
  var dtSkuRowEl     = document.getElementById('v2-dt-sku-row');
  var dtSizeEl       = document.getElementById('v2-dt-size');
  var atcNoteEl      = document.getElementById('v2-atc-note');

  /* ── Cart-quantity tracking (drives the "already in cart" button state) ── */
  var cartQty = {};
  function isVariantMaxed(variant) {
    if (!variant) return false;
    var qtyInCart = cartQty[variant.id] || 0;
    if (qtyInCart <= 0) return false;
    var inv = inventoryData[String(variant.id)];
    if (!inv) return false;
    return inv.inventory_management === 'shopify' &&
      inv.inventory_policy !== 'continue' &&
      qtyInCart >= inv.inventory_quantity;
  }
  function setAtcState(variant) {
    if (!atcBtn || !variant) return;
    if (isVariantMaxed(variant)) {
      atcBtn.classList.add('v2-btn-atc--in-cart');
      atcBtn.disabled = false;
      if (atcText) atcText.textContent = atcBtn.dataset.inCartText || 'Secure Checkout';
      if (atcNoteEl) atcNoteEl.hidden = false;
      if (stockEl) stockEl.hidden = true;
    } else {
      atcBtn.classList.remove('v2-btn-atc--in-cart');
      atcBtn.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? (atcBtn.dataset.addText || 'Add to Cart') : (atcBtn.dataset.soldText || 'Sold Out');
      if (atcNoteEl) atcNoteEl.hidden = true;
      if (stockEl) stockEl.hidden = false;
    }
  }
  function syncCartQty(cart) {
    cartQty = {};
    (cart.items || []).forEach(function (item) { cartQty[item.variant_id] = item.quantity; });
    var v = findVariant(variantIdInput ? variantIdInput.value : null);
    if (v) setAtcState(v);
  }
  fetch('/cart.js').then(function (r) { return r.json(); }).then(syncCartQty).catch(function () {});

  /* Cart drawer dispatches this on every add/remove/qty-change/refresh —
     keeps the button state correct even after edits made in the drawer. */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) syncCartQty(e.detail.cart);
  });

  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl)  priceEl.textContent = formatMoney(variant.price);
    setAtcState(variant);
    var showCmp = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
    if (priceEl) priceEl.classList.toggle('v2-price--sale', showCmp);
    if (bfChipEl) bfChipEl.style.display = showCmp ? '' : 'none';
    if (compareEl) {
      compareEl.textContent = showCmp ? formatMoney(variant.compare_at_price) : '';
      compareEl.style.display = showCmp ? '' : 'none';
    }
    if (badgeEl) {
      badgeEl.style.display = showCmp ? '' : 'none';
      if (showCmp) {
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        if (saveAmtEl) saveAmtEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
        if (savePctEl) savePctEl.textContent = pct + '% off';
      }
    }
    if (stockEl) {
      var sInv = inventoryData[String(variant.id)];
      var sQty = sInv && sInv.inventory_management === 'shopify' ? sInv.inventory_quantity : 0;
      var showStock = variant.available && sQty > 0 && sQty <= 5;
      stockEl.innerHTML = showStock ? 'One of a kind<span class="v2-price-save__sep" aria-hidden="true">&middot;</span>Only ' + sQty + ' available' : '';
      stockEl.style.display = showStock ? '' : 'none';
    }
    if (attrSizeEl && variant.title !== 'Default Title') {
      var svgEl = attrSizeEl.querySelector('svg');
      attrSizeEl.textContent = variant.title;
      if (svgEl) attrSizeEl.insertBefore(svgEl, attrSizeEl.firstChild);
    }
    if (dtSizeEl && variant.title !== 'Default Title') dtSizeEl.textContent = variant.title;
    var upsellSzEl = document.getElementById('v2-upsell-size');
    if (upsellSzEl && variant.title !== 'Default Title') upsellSzEl.textContent = variant.title;
    if (dtSkuEl) {
      dtSkuEl.textContent = variant.sku || '';
      if (dtSkuRowEl) dtSkuRowEl.style.display = variant.sku ? '' : 'none';
    }
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }
  }

  /* ── SKU copy ── */
  if (dtSkuEl) {
    dtSkuEl.addEventListener('click', function () {
      var sku = dtSkuEl.textContent.trim();
      navigator.clipboard.writeText(sku).then(function () {
        var orig = dtSkuEl.textContent;
        dtSkuEl.textContent = 'Copied!';
        dtSkuEl.classList.add('v2-dt-sku--copied');
        setTimeout(function () {
          dtSkuEl.textContent = orig;
          dtSkuEl.classList.remove('v2-dt-sku--copied');
        }, 1800);
      });
    });
  }

  /* ── Colour swatches ── */
  var colourSwatches = document.querySelectorAll('.v2-swatch');
  colourSwatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optIdx   = parseInt(this.dataset.optionIndex, 10);
      var colVal   = this.dataset.colour;
      var optKey   = ['option1','option2','option3'][optIdx];
      colourSwatches.forEach(function (b) { b.classList.remove('v2-swatch--active'); b.setAttribute('aria-pressed','false'); });
      this.classList.add('v2-swatch--active'); this.setAttribute('aria-pressed','true');
      var lbl = document.getElementById('v2-colour-lbl');
      if (lbl) lbl.textContent = colVal;
      if (!productData) return;
      var curId  = variantIdInput ? variantIdInput.value : null;
      var cur    = findVariant(curId);
      var match  = productData.variants.find(function (v) {
        if (v[optKey] !== colVal) return false;
        if (cur) { return ['option1','option2','option3'].filter(function(k){return k!==optKey;}).every(function(k){return !cur[k]||v[k]===cur[k];}); }
        return true;
      }) || productData.variants.find(function(v){ return v[optKey]===colVal && v.available; }) || productData.variants.find(function(v){ return v[optKey]===colVal; });
      if (match) { applyVariant(match); syncSel(match); }
    });
  });

  /* ── Custom select ── */
  var selEl = document.getElementById('v2-sel');
  function syncSel(variant) {
    if (!selEl || !variant) return;
    var opts = selEl.querySelectorAll('.v2-sel__opt');
    var lblEl = document.getElementById('v2-sel-label');
    var imgEl = document.getElementById('v2-sel-img');
    opts.forEach(function(o){
      var sel = String(o.dataset.variantId) === String(variant.id);
      o.classList.toggle('v2-sel__opt--sel', sel);
      o.setAttribute('aria-selected', sel);
      if (sel && lblEl) lblEl.textContent = o.dataset.sizeLabel;
      if (sel && imgEl) {
        var img = o.dataset.sizeImg;
        if (img && img !== 'null' && img !== '') { imgEl.src = img; imgEl.style.display = ''; }
        else imgEl.style.display = 'none';
      }
    });
  }
  if (selEl) {
    var trigger = selEl.querySelector('.v2-sel__trigger');
    var opts    = selEl.querySelectorAll('.v2-sel__opt');
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = selEl.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open);
    });
    opts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        if (this.classList.contains('v2-sel__opt--dis')) return;
        var variant = findVariant(this.dataset.variantId);
        opts.forEach(function(o){ o.classList.remove('v2-sel__opt--sel'); o.setAttribute('aria-selected','false'); });
        this.classList.add('v2-sel__opt--sel'); this.setAttribute('aria-selected','true');
        var lbl = document.getElementById('v2-sel-label');
        var img = document.getElementById('v2-sel-img');
        if (lbl) lbl.textContent = this.dataset.sizeLabel;
        if (img) { var si = this.dataset.sizeImg; if (si && si!=='null'&&si!==''){img.src=si;img.style.display='';}else img.style.display='none'; }
        selEl.classList.remove('is-open'); trigger.setAttribute('aria-expanded','false'); trigger.focus();
        if (variant) applyVariant(variant);
      });
    });
    document.addEventListener('click', function(e){ if (!selEl.contains(e.target)){ selEl.classList.remove('is-open'); trigger.setAttribute('aria-expanded','false'); } });
  }

  /* ── Native select ── */
  var nativeSel = document.getElementById('v2-variant-select');
  if (nativeSel) nativeSel.addEventListener('change', function(){ var v = findVariant(this.value); if (v) applyVariant(v); });

  /* ── ATC form ── */
  (function(){
    var form = document.getElementById('v2-product-form');
    if (!form) return;
    var atcRow = form.querySelector('.v2-btn-atc');
    var errEl = document.createElement('p');
    errEl.className = 'v2-atc-error'; errEl.setAttribute('aria-live','polite'); errEl.hidden = true;
    errEl.style.cssText = 'font-size:13px;color:#b04a2e;margin:-4px 0 14px;';
    if (atcRow) atcRow.insertAdjacentElement('afterend', errEl);
    var errTimer = null;
    function showErr(msg){ errEl.textContent=msg; errEl.hidden=false; clearTimeout(errTimer); errTimer=setTimeout(function(){errEl.hidden=true;},6000); }
    function hideErr(){ clearTimeout(errTimer); errEl.hidden=true; }
    function restoreBtn(){ setAtcState(findVariant(variantIdInput ? variantIdInput.value : null)); }
    function goToCheckout(){
      var f = document.createElement('form');
      f.method = 'post';
      f.action = atcBtn.dataset.cartUrl || '/cart';
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'checkout'; i.value = '';
      f.appendChild(i);
      document.body.appendChild(f);
      f.submit();
    }
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if (atcBtn && atcBtn.classList.contains('v2-btn-atc--in-cart')) { goToCheckout(); return; }
      if (atcBtn && atcBtn.disabled) return;
      var varId = variantIdInput ? variantIdInput.value : null;
      if (!varId) return;
      hideErr();
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Adding…';
      var mainItem = { id: parseInt(varId, 10), quantity: 1 };
      var sizeInput = form.querySelector('input[name="properties[_size]"]');
      if (sizeInput && sizeInput.value) {
        mainItem.properties = { '_size': sizeInput.value };
      }
      var items = [mainItem];
      var upsellChk = document.getElementById('v2-upsell-chk');
      if (upsellChk && upsellChk.checked && upsellChk.dataset.variantId) {
        items.push({ id: parseInt(upsellChk.dataset.variantId, 10), quantity: 1 });
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){ return r.json().then(function(d){ if (!r.ok) throw d; return d; }); })
      .then(function(addedData){
        if (window.fbq && addedData && addedData.items) {
          var ids = addedData.items.map(function(it){ return String(it.product_id); });
          var val = addedData.items.reduce(function(sum, it){ return sum + it.line_price; }, 0) / 100;
          fbq('track', 'AddToCart', {
            content_ids: ids,
            content_type: 'product',
            value: val,
            currency: '{{ cart.currency.iso_code }}'
          });
        }
        cartQty[varId] = (cartQty[varId] || 0) + 1;
        if (window.clarity) { window.clarity('event', 'AddToCart'); }
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          document.dispatchEvent(new CustomEvent('cart:item-added',{detail:{cart:cart}}));
          document.querySelectorAll('.cart-count').forEach(function(b){ b.textContent=cart.item_count; b.style.display=cart.item_count>0?'':'none'; });
          if (cart.item_count>0) {
            document.querySelectorAll('.cart-btn').forEach(function(btn){
              if (!btn.querySelector('.cart-count')){ var c=document.createElement('span'); c.className='cart-count'; c.setAttribute('aria-hidden','true'); c.textContent=cart.item_count; btn.insertBefore(c,btn.firstChild); }
            });
          }
        });
        if (atcText) atcText.textContent = 'Added to Cart';
        if (window.CartDrawer && typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
        setTimeout(restoreBtn, 1500);
      })
      .catch(function(err){
        var isInv = err && (err.status===422 || (typeof err.description==='string' && /quantity|stock|inventory/i.test(err.description)));
        if (isInv) {
          var v = findVariant(varId);
          var inv = inventoryData[String(varId)];
          cartQty[varId] = inv ? inv.inventory_quantity : ((cartQty[varId] || 0) + 1);
          if (v) setAtcState(v); else restoreBtn();
          showErr('The maximum quantity of this item is already in your cart.');
        } else {
          restoreBtn();
        }
      });
    });
  })();

  /* ── Wishlist ── */
  (function () {
    var fav = window.NileFavourites;
    if (!fav) return;
    var btn = document.getElementById('v2-btn-fav');
    if (!btn) return;

    function setState(active) {
      var icon = btn.querySelector('i');
      if (active) {
        btn.classList.add('v2-btn-fav--active');
        btn.setAttribute('aria-label', btn.dataset.removeLabel || 'Remove from favourites');
        if (icon) icon.className = 'fa-solid fa-heart';
      } else {
        btn.classList.remove('v2-btn-fav--active');
        btn.setAttribute('aria-label', btn.dataset.addLabel || 'Add to favourites');
        if (icon) icon.className = 'fa-regular fa-heart';
      }
    }

    setState(fav.has(btn.dataset.favId));

    btn.addEventListener('click', function () {
      var added = fav.toggle({
        id:    btn.dataset.favId,
        title: btn.dataset.favTitle,
        url:   btn.dataset.favUrl,
        image: btn.dataset.favImage,
        price: btn.dataset.favPrice
      });
      setState(added);
      if (added) {
        var rect  = btn.getBoundingClientRect();
        var heart = document.createElement('span');
        heart.className = 'prd-floating-heart';
        heart.setAttribute('aria-hidden', 'true');
        heart.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
        heart.style.left = (rect.left + rect.width / 2 - 11) + 'px';
        heart.style.top  = (rect.top - 4) + 'px';
        document.body.appendChild(heart);
        heart.addEventListener('animationend', function () { heart.remove(); });
      }
    });

    /* -- Similar product card hearts -- */
    var simWishes = document.querySelectorAll('.sim-card__wish[data-fav-id]');
    Array.prototype.forEach.call(simWishes, function (simBtn) {
      function setSimState(active) {
        var icon = simBtn.querySelector('i');
        if (active) {
          simBtn.classList.add('sim-card__wish--active');
          simBtn.setAttribute('aria-label', 'Remove from favourites');
          if (icon) { icon.className = 'fa-solid fa-heart'; }
        } else {
          simBtn.classList.remove('sim-card__wish--active');
          simBtn.setAttribute('aria-label', 'Add to favourites');
          if (icon) { icon.className = 'fa-regular fa-heart'; }
        }
      }

      setSimState(fav.has(simBtn.dataset.favId));

      simBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var product = {
          id:    simBtn.dataset.favId,
          title: simBtn.dataset.favTitle,
          url:   simBtn.dataset.favUrl,
          image: simBtn.dataset.favImage,
          price: simBtn.dataset.favPrice
        };
        var added = fav.toggle(product);
        setSimState(added);
        if (added) {
          var rect  = simBtn.getBoundingClientRect();
          var heart = document.createElement('span');
          heart.className = 'prd-floating-heart';
          heart.setAttribute('aria-hidden', 'true');
          heart.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
          heart.style.left = (rect.left + rect.width / 2 - 11) + 'px';
          heart.style.top  = (rect.top - 4) + 'px';
          document.body.appendChild(heart);
          heart.addEventListener('animationend', function () { heart.remove(); });
        }
      });
    });
  })();


  /* ── Recently Viewed ── */
  (function(){
    var RV_KEY = 'nile_rv_v1'; var RV_MAX = 20; var RV_SHOW = 8;
    if (!productData) return;
    var curId = productData.id;
    function getRV(){ try { return JSON.parse(localStorage.getItem(RV_KEY)||'[]'); } catch(e){ return []; } }
    function saveRV(a){ try { localStorage.setItem(RV_KEY,JSON.stringify(a)); } catch(e){} }
    function rvImgUrl(src,w){ if(!src)return''; return src.replace(/(\.[^.?]+)(\?.*)?$/,function(_,ext,qs){return '_'+w+'x'+ext+(qs||'');}); }
    var rv = getRV();
    rv = rv.filter(function(p){ return p.id !== curId; });
    var rvCmp = productData.compare_at_price && productData.compare_at_price > productData.price ? productData.compare_at_price : 0;
    rv.unshift({ id:curId, title:productData.title, url:'/products/'+productData.handle, image:rvImgUrl(productData.featured_image,400), price:formatMoney(productData.price), priceCents:productData.price, compareAtPrice:rvCmp?formatMoney(rvCmp):null, discountPct:rvCmp?Math.round((rvCmp-productData.price)/rvCmp*100):0 });
    if (rv.length > RV_MAX) rv = rv.slice(0, RV_MAX);
    saveRV(rv);
    var toShow = getRV().filter(function(p){ return p.id !== curId; }).slice(0, RV_SHOW);
    if (!toShow.length) return;
    var section = document.getElementById('v2-rv-prods');
    if (!section) return;
    var track = section.querySelector('.v2-rv-track');
    if (!track) return;
    var vd = window.v2VintageDiscount || { enabled: false, amount: 0 };
    toShow.forEach(function(p){
      var a = document.createElement('a');
      a.className = 'sim-card'; a.href = p.url;
      var imgHtml = p.image ? '<img class="sim-card__img" src="'+p.image+'" alt="'+(p.title||'').replace(/</g,'&lt;').replace(/"/g,'&quot;')+'" loading="lazy">' : '';
      var showVintage = vd.enabled && typeof p.priceCents === 'number' && (p.title||'').toLowerCase().indexOf('vintage') !== -1;
      var vintagePromoHtml = '';
      if (showVintage) {
        var vOffCents = vd.amount * 100;
        var vPriceCents = Math.max(0, p.priceCents - vOffCents);
        vintagePromoHtml = '<div class="sim-card__promo-row"><span class="sim-card__promo-price">Your price: '+formatMoney(vPriceCents)+'</span><span class="sim-card__promo-chip">Extra '+formatMoney(vOffCents)+' off</span></div>';
      }
      a.innerHTML = '<div class="sim-card__img-wrap">'+imgHtml+'</div><div class="sim-card__info"><p class="sim-card__name"></p><div class="sim-card__price-row">'+(p.compareAtPrice?'<s class="sim-card__price-compare"></s>':'')+'<span class="sim-card__price'+(p.compareAtPrice?' sim-card__price--sale':'')+'"></span></div>'+vintagePromoHtml+'</div>';
      var rvTitle = p.title||'';
      if (rvTitle.length > 28) rvTitle = rvTitle.slice(0, 25) + '...';
      a.querySelector('.sim-card__name').textContent = rvTitle;
      a.querySelector('.sim-card__price').textContent = p.price||'';
      if (p.compareAtPrice) a.querySelector('.sim-card__price-compare').textContent = p.compareAtPrice;
      track.appendChild(a);
    });
    section.style.display = '';
  })();

})();

/* ── Mobile swipe gallery counter ── */
(function () {
  var mq = window.matchMedia('(max-width: 700px)');
  if (!mq.matches) return;
  var gallery   = document.getElementById('v2-mob-gallery');
  var counterEl = document.getElementById('v2-mob-counter');
  if (!gallery || !counterEl) return;

  var slides = Array.from(gallery.querySelectorAll('.v2-mob-slide'));
  var total  = slides.length;
  if (!total) return;

  /* Force eager loading so swiping doesn't show blanks */
  slides.forEach(function (s) {
    var img = s.querySelector('img');
    if (img) img.loading = 'eager';
  });

  function updateCounter() {
    var w = gallery.clientWidth;
    if (!w) return;
    var idx = Math.min(total - 1, Math.max(0, Math.round(gallery.scrollLeft / w)));
    counterEl.textContent = (idx + 1) + ' / ' + total;
  }

  gallery.addEventListener('scroll', updateCounter, { passive: true });
  requestAnimationFrame(updateCounter);

  /* ── Pinch-to-zoom ── */
  var _pinching   = false;
  var _startDist  = 0;
  var _startScale = 1;
  var _scale      = 1;
  var _zoomedImg  = null;
  var MAX_SCALE   = 4;

  function getTouchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function resetZoom() {
    _scale    = 1;
    _pinching = false;
    if (_zoomedImg) {
      _zoomedImg.style.transform       = '';
      _zoomedImg.style.transformOrigin = '';
      _zoomedImg = null;
    }
  }

  gallery.addEventListener('scroll', function () {
    resetZoom();
  }, { passive: true });

  gallery.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 2) return;
    e.preventDefault();
    _pinching   = true;
    _startDist  = getTouchDist(e.touches);
    _startScale = _scale;
    var idx = Math.min(total - 1, Math.max(0, Math.round(gallery.scrollLeft / gallery.clientWidth)));
    _zoomedImg  = slides[idx] ? slides[idx].querySelector('img') : null;
  }, { passive: false });

  gallery.addEventListener('touchmove', function (e) {
    if (!_pinching || e.touches.length < 2) return;
    e.preventDefault();
    _scale = Math.min(MAX_SCALE, Math.max(1, _startScale * (getTouchDist(e.touches) / _startDist)));
    if (_zoomedImg) {
      _zoomedImg.style.transform       = 'scale(' + _scale + ')';
      _zoomedImg.style.transformOrigin = 'center center';
    }
  }, { passive: false });

  gallery.addEventListener('touchend', function (e) {
    if (e.touches.length < 2) {
      _pinching = false;
      if (_scale < 1.05) resetZoom();
    }
  }, { passive: true });
})();

/* ── Fullscreen mobile image viewer (tap to open, swipe left/right, dot indicators) ── */
(function () {
  var mq = window.matchMedia('(max-width: 700px)');
  if (!mq.matches) return;

  var mainGallery = document.getElementById('v2-mob-gallery');
  var viewer      = document.getElementById('v2-fs-viewer');
  var track       = document.getElementById('v2-fs-track');
  var dotsWrap    = document.getElementById('v2-fs-dots');
  var closeBtn    = document.getElementById('v2-fs-close');
  if (!mainGallery || !viewer || !track) return;

  var mainSlides = Array.from(mainGallery.querySelectorAll('.v2-mob-slide'));
  var fsSlides   = Array.from(track.querySelectorAll('.v2-fs-slide'));
  var dots       = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.v2-fs-dot')) : [];
  var total      = fsSlides.length;
  if (!total) return;

  if (total < 2 && dotsWrap) dotsWrap.style.display = 'none';

  function setActiveDot(idx) {
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
  }

  /* ── Zoom / pan state (one active slide at a time) ── */
  var MAX_SCALE  = 4;
  var TAP_SCALE  = 2.5;
  var zoomScale  = 1;
  var panX = 0, panY = 0;
  var activeImg = null, activeSlideEl = null;

  function updateTrackMode() {
    track.classList.toggle('is-zoomed', zoomScale > 1.01);
  }

  function setGesturing(on) {
    if (activeImg) activeImg.classList.toggle('is-gesturing', on);
  }

  function applyTransform() {
    if (activeImg) {
      activeImg.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomScale + ')';
    }
    updateTrackMode();
  }

  function clampPan() {
    if (!activeImg || !activeSlideEl) return;
    var baseW = activeImg.offsetWidth;
    var baseH = activeImg.offsetHeight;
    var cw = activeSlideEl.clientWidth;
    var ch = activeSlideEl.clientHeight;
    var maxPanX = Math.max(0, (baseW * zoomScale - cw) / 2);
    var maxPanY = Math.max(0, (baseH * zoomScale - ch) / 2);
    panX = Math.min(maxPanX, Math.max(-maxPanX, panX));
    panY = Math.min(maxPanY, Math.max(-maxPanY, panY));
  }

  function resetZoomState() {
    zoomScale = 1;
    panX = 0;
    panY = 0;
    if (activeImg) {
      setGesturing(false);
      activeImg.style.transform = '';
    }
    activeImg = null;
    activeSlideEl = null;
    updateTrackMode();
  }

  function toggleZoomAt(slide, clientX, clientY) {
    activeSlideEl = slide;
    activeImg = slide.querySelector('img');
    if (!activeImg) return;
    setGesturing(false); /* animate this one */
    if (zoomScale > 1.01) {
      resetZoomState();
      return;
    }
    zoomScale = TAP_SCALE;
    var rect = slide.getBoundingClientRect();
    var offsetX = clientX - rect.left - rect.width / 2;
    var offsetY = clientY - rect.top - rect.height / 2;
    panX = -offsetX * (zoomScale - 1);
    panY = -offsetY * (zoomScale - 1);
    clampPan();
    applyTransform();
  }

  /* ── Hide the Shopify chat bubble while the viewer is open (same
     shadow-DOM-piercing approach used by the cart drawer, since the chat
     widget lives inside nested shadow roots and plain CSS can't reach it) ── */
  function findChatHost(root) {
    if (!root) return null;
    var btn = root.querySelector('[part="activator"], .activator, [aria-label="Chat"]');
    if (btn) {
      var rootNode = btn.getRootNode();
      return (rootNode && rootNode.host) ? rootNode.host : null;
    }
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) {
        var found = findChatHost(els[i].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function setChatHidden(hidden) {
    var host = findChatHost(document);
    if (!host) return;
    if (hidden) host.style.setProperty('display', 'none', 'important');
    else host.style.removeProperty('display');
  }

  function openViewer(idx) {
    fsSlides.forEach(function (s) {
      var img = s.querySelector('img');
      if (img) img.loading = 'eager';
    });
    resetZoomState();
    viewer.classList.add('is-open');
    viewer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setChatHidden(true);
    track.scrollLeft = idx * track.clientWidth;
    setActiveDot(idx);
  }

  function closeViewer() {
    resetZoomState();
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden', 'true');
    setChatHidden(false);
    document.body.style.overflow = '';
  }

  mainSlides.forEach(function (slide, i) {
    slide.addEventListener('click', function () {
      openViewer(i);
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeViewer();
    });
  }

  track.addEventListener('scroll', function () {
    var w = track.clientWidth;
    if (!w) return;
    if (zoomScale > 1.01) resetZoomState();
    var idx = Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    setActiveDot(idx);
  }, { passive: true });

  dots.forEach(function (d) {
    d.addEventListener('click', function (e) {
      e.stopPropagation();
      var idx = parseInt(d.getAttribute('data-index'), 10) || 0;
      track.scrollLeft = idx * track.clientWidth;
    });
  });

  window.addEventListener('resize', function () {
    if (!viewer.classList.contains('is-open')) return;
    var activeIdx = 0;
    dots.forEach(function (d, i) {
      if (d.classList.contains('is-active')) activeIdx = i;
    });
    track.scrollLeft = activeIdx * track.clientWidth;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && viewer.classList.contains('is-open')) closeViewer();
  });

  /* ── Touch gestures: pinch-to-zoom, pan-when-zoomed, double-tap-to-zoom, tap-to-close ── */
  function touchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function touchMid(touches) {
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2
    };
  }

  var gesture = { mode: null, startDist: 0, startScale: 1, startPanX: 0, startPanY: 0, startX: 0, startY: 0, startMidX: 0, startMidY: 0 };
  var lastTapTime = 0, lastTapX = 0, lastTapY = 0;
  var pendingTapTimer = null;
  var movedBeyondTapThreshold = false;

  track.addEventListener('touchstart', function (e) {
    var slide = e.target.closest ? e.target.closest('.v2-fs-slide') : null;
    if (!slide) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      if (pendingTapTimer) { clearTimeout(pendingTapTimer); pendingTapTimer = null; }
      activeSlideEl = slide;
      activeImg = slide.querySelector('img');
      setGesturing(true);
      var startMid = touchMid(e.touches);
      gesture.mode       = 'pinch';
      gesture.startDist  = touchDist(e.touches);
      gesture.startScale = zoomScale;
      gesture.startPanX  = panX;
      gesture.startPanY  = panY;
      gesture.startMidX  = startMid.x;
      gesture.startMidY  = startMid.y;
      return;
    }

    if (e.touches.length === 1) {
      /* Single finger: don't decide pan-vs-tap yet. If already zoomed and the
         finger moves, touchmove will treat it as a pan; if it never moves,
         touchend treats it as a tap (so double-tap-to-zoom-out still works). */
      var tx = e.touches[0].clientX, ty = e.touches[0].clientY;
      /* This may be the 2nd tap of a double-tap — pre-empt the browser's own
         native double-tap-zoom (which would zoom the whole page, not our
         image, and desync it from our zoomScale variable). */
      var mightBeDoubleTap = (Date.now() - lastTapTime < 300) &&
        Math.abs(tx - lastTapX) < 30 && Math.abs(ty - lastTapY) < 30;
      if (mightBeDoubleTap) e.preventDefault();

      activeSlideEl = slide;
      activeImg = slide.querySelector('img');
      gesture.mode      = 'touch1';
      gesture.startX    = tx;
      gesture.startY    = ty;
      gesture.startPanX = panX;
      gesture.startPanY = panY;
      movedBeyondTapThreshold = false;
    }
  }, { passive: false });

  track.addEventListener('touchmove', function (e) {
    if (gesture.mode === 'pinch' && e.touches.length === 2) {
      e.preventDefault();
      var newDist = touchDist(e.touches);
      var newMid  = touchMid(e.touches);
      zoomScale = Math.min(MAX_SCALE, Math.max(1, gesture.startScale * (newDist / gesture.startDist)));
      panX = gesture.startPanX + (newMid.x - gesture.startMidX);
      panY = gesture.startPanY + (newMid.y - gesture.startMidY);
      clampPan();
      applyTransform();
      return;
    }
    if (gesture.mode === 'touch1' && e.touches.length === 1) {
      var dx = e.touches[0].clientX - gesture.startX;
      var dy = e.touches[0].clientY - gesture.startY;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) movedBeyondTapThreshold = true;
      if (zoomScale > 1.01) {
        e.preventDefault();
        setGesturing(true);
        panX = gesture.startPanX + dx;
        panY = gesture.startPanY + dy;
        clampPan();
        applyTransform();
      }
    }
  }, { passive: false });

  function endGesture(e) {
    if (gesture.mode === 'pinch' && e.touches.length === 1) {
      /* seamlessly continue as a pan with the remaining finger */
      gesture.mode      = 'touch1';
      gesture.startX    = e.touches[0].clientX;
      gesture.startY    = e.touches[0].clientY;
      gesture.startPanX = panX;
      gesture.startPanY = panY;
      movedBeyondTapThreshold = true;
      return;
    }
    if (e.touches.length > 0) return;

    var wasGesture = (gesture.mode === 'pinch') || movedBeyondTapThreshold;
    if (wasGesture) {
      setGesturing(false);
      if (zoomScale <= 1.02) resetZoomState();
      gesture.mode = null;
      return;
    }
    if (gesture.mode === 'touch1') {
      var slide = e.target.closest ? e.target.closest('.v2-fs-slide') : null;
      if (slide) {
        if (e.cancelable) e.preventDefault(); /* swallow native double-tap-zoom / ghost click */
        var tapX = gesture.startX, tapY = gesture.startY;
        var now = Date.now();
        var isDouble = (now - lastTapTime < 300) && Math.abs(tapX - lastTapX) < 30 && Math.abs(tapY - lastTapY) < 30;
        if (isDouble) {
          if (pendingTapTimer) { clearTimeout(pendingTapTimer); pendingTapTimer = null; }
          lastTapTime = 0;
          toggleZoomAt(slide, tapX, tapY);
        } else {
          lastTapTime = now;
          lastTapX = tapX;
          lastTapY = tapY;
          pendingTapTimer = setTimeout(function () {
            pendingTapTimer = null;
            if (zoomScale <= 1.01) closeViewer();
          }, 300);
        }
      }
    }
  }

  track.addEventListener('touchend', endGesture, { passive: false });
  track.addEventListener('touchcancel', endGesture, { passive: false });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
/* ── Product page testimonial slider ── */
(function () {
  'use strict';
  var track   = document.getElementById('prd-testi-track');
  if (!track) return;
  var progress = document.querySelector('.prd-testi-progress[data-target="prd-testi-track"]');
  var fill     = progress && progress.querySelector('.prd-testi-progress__fill');
  var btnPrev  = document.querySelector('.prd-testi-arrow--prev[data-target="prd-testi-track"]');
  var btnNext  = document.querySelector('.prd-testi-arrow--next[data-target="prd-testi-track"]');

  function scrollBy(dir) {
    var card = track.querySelector('.prd-testi__card');
    var gap  = parseInt(getComputedStyle(track).gap) || 20;
    var step = card ? card.offsetWidth + gap : track.clientWidth * 0.85;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { scrollBy(-1); });
  if (btnNext) btnNext.addEventListener('click', function () { scrollBy(1); });

  function update() {
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 2) {
      if (btnPrev) btnPrev.classList.add('is-hidden');
      if (btnNext) btnNext.classList.add('is-hidden');
      return;
    }
    var pct = track.scrollLeft / max;
    if (fill) fill.style.width = (pct * 100) + '%';
    if (btnPrev) btnPrev.classList.toggle('is-hidden', track.scrollLeft <= 2);
    if (btnNext) btnNext.classList.toggle('is-hidden', track.scrollLeft >= max - 2);
  }

  requestAnimationFrame(update);

  var ticking = false;
  track.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () { update(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
})();

(function () {
  'use strict';

  /* ---- Data ---- */
  var productDataEl = document.getElementById('prd-data');
  var productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;

  function formatMoney(cents) {
    var LB = '{' + '{';
    var fmt = window.prdMoneyFormat || (LB + ' amount }}');
    var amount = cents / 100;
    var str = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    var result = fmt
      .replace(LB + ' amount }}', str)
      .replace(LB + 'amount }}', str)
      .replace(LB + 'amount}' + '}', str)
      .replace(LB + ' amount_no_decimals }}', Math.round(amount))
      .replace(LB + 'amount_no_decimals}}', Math.round(amount))
      .replace(LB + ' amount_with_comma_separator }}', str.replace('.', ','))
      .replace(LB + 'amount_with_comma_separator}}', str.replace('.', ','))
      .replace(LB + ' amount_no_decimals_with_comma_separator }}', Math.round(amount))
      .replace(LB + 'amount_no_decimals_with_comma_separator}}', Math.round(amount));
    // Strip any HTML tags (e.g. <span class="money">...</span> from shop.money_format)
    return result.replace(/<[^>]+>/g, '').trim();
  }

  /* ---- Elements ---- */
  var variantIdInput  = document.getElementById('prd-variant-id');
  var priceEl         = document.getElementById('prd-price');
  var comparePriceEl  = document.getElementById('prd-price-compare');
  var priceBadgeEl    = document.querySelector('.prd-price-badge');
  var atcBtn          = document.getElementById('prd-btn-atc');
  var atcText         = document.getElementById('prd-btn-atc-text');
  var colourLabel     = document.getElementById('prd-colour-label');
  var sizeHint        = document.getElementById('prd-size-hint');
  var skuEl           = document.getElementById('prd-sku');
  var skuValueEl      = document.getElementById('prd-sku-value');
  /* Keep a ref to the first text node in size hint so we don't wipe the SVG icon */
  var sizeHintTextNode = sizeHint ? (function () {
    for (var i = 0; i < sizeHint.childNodes.length; i++) {
      if (sizeHint.childNodes[i].nodeType === 3) return sizeHint.childNodes[i];
    }
    return null;
  })() : null;

  /* ---- Variant update ---- */
  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl)        priceEl.textContent = formatMoney(variant.price);
    if (atcBtn)         atcBtn.disabled = !variant.available;
    if (atcText)        atcText.textContent = variant.available ? (atcBtn.dataset.addText || 'Add to cart') : (atcBtn.dataset.soldText || 'Sold out');
    if (comparePriceEl) {
      var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      comparePriceEl.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
      comparePriceEl.style.display = showCompare ? '' : 'none';
      if (priceBadgeEl) {
        priceBadgeEl.style.display = showCompare ? '' : 'none';
        if (showCompare) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          priceBadgeEl.textContent = '-' + pct + '%';
        }
      }
    }
    if (sizeHintTextNode && variant.title !== 'Default Title') sizeHintTextNode.textContent = variant.title + ' ';

    if (skuEl && skuValueEl) {
      if (variant.sku) {
        skuValueEl.textContent = variant.sku;
        skuEl.style.display = '';
      } else {
        skuEl.style.display = 'none';
      }
    }

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }
  }

  function findVariantById(id) {
    if (!productData) return null;
    return productData.variants.find(function (v) { return String(v.id) === String(id); }) || null;
  }

  /* ---- Colour swatches ---- */
  var colourSwatches = document.querySelectorAll('.prd-colour-swatch');
  colourSwatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionIndex = parseInt(this.dataset.optionIndex, 10);
      var colourValue = this.dataset.colour;
      var optionKey   = ['option1', 'option2', 'option3'][optionIndex];

      colourSwatches.forEach(function (b) {
        b.classList.remove('prd-colour-swatch--active');
        b.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('prd-colour-swatch--active');
      this.setAttribute('aria-pressed', 'true');

      if (colourLabel) colourLabel.textContent = colourValue;

      if (!productData) return;
      var currentId = variantIdInput ? variantIdInput.value : null;
      var current   = findVariantById(currentId);

      /* Try to preserve other options when switching colour */
      var match = productData.variants.find(function (v) {
        if (v[optionKey] !== colourValue) return false;
        if (current) {
          var otherOpts = ['option1','option2','option3'].filter(function (k) { return k !== optionKey; });
          return otherOpts.every(function (k) { return !current[k] || v[k] === current[k]; });
        }
        return true;
      }) || productData.variants.find(function (v) {
        return v[optionKey] === colourValue && v.available;
      }) || productData.variants.find(function (v) {
        return v[optionKey] === colourValue;
      });

      if (match) {
        applyVariant(match);
        syncCustomSelect(match);
      }
    });
  });

  /* ---- Custom size select ---- */
  var customSelect = document.getElementById('prd-custom-select');

  function syncCustomSelect(variant) {
    if (!customSelect || !variant) return;
    var options = customSelect.querySelectorAll('.prd-custom-select__option');
    var labelEl = document.getElementById('prd-size-label');
    var imgEl   = document.getElementById('prd-size-img');

    options.forEach(function (opt) {
      var selected = String(opt.dataset.variantId) === String(variant.id);
      opt.classList.toggle('prd-custom-select__option--selected', selected);
      opt.setAttribute('aria-selected', selected);
      if (selected && labelEl) labelEl.textContent = opt.dataset.sizeLabel;
      if (selected && imgEl) {
        var img = opt.dataset.sizeImg;
        if (img && img !== 'null' && img !== '') {
          imgEl.src = img;
          imgEl.style.display = '';
        } else {
          imgEl.style.display = 'none';
        }
      }
    });
  }

  if (customSelect) {
    var trigger  = customSelect.querySelector('.prd-custom-select__trigger');
    var optionEls = customSelect.querySelectorAll('.prd-custom-select__option');

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = customSelect.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open);
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger.click();
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!customSelect.classList.contains('is-open')) {
          customSelect.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        var opts = Array.from(optionEls).filter(function (o) { return !o.classList.contains('prd-custom-select__option--disabled'); });
        var target = e.key === 'ArrowDown' ? opts[0] : opts[opts.length - 1];
        if (target) target.focus();
      }
    });

    optionEls.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (this.classList.contains('prd-custom-select__option--disabled')) return;
        var variantId = this.dataset.variantId;
        var variant   = findVariantById(variantId);

        optionEls.forEach(function (o) {
          o.classList.remove('prd-custom-select__option--selected');
          o.setAttribute('aria-selected', 'false');
        });
        this.classList.add('prd-custom-select__option--selected');
        this.setAttribute('aria-selected', 'true');

        var labelEl = document.getElementById('prd-size-label');
        var imgEl   = document.getElementById('prd-size-img');
        if (labelEl) labelEl.textContent = this.dataset.sizeLabel;
        if (imgEl) {
          var img = this.dataset.sizeImg;
          if (img && img !== 'null' && img !== '') { imgEl.src = img; imgEl.style.display = ''; }
          else { imgEl.style.display = 'none'; }
        }

        customSelect.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
        if (variant) applyVariant(variant);
      });

      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = this.nextElementSibling;
          while (next && next.classList.contains('prd-custom-select__option--disabled')) next = next.nextElementSibling;
          if (next) next.focus();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = this.previousElementSibling;
          while (prev && prev.classList.contains('prd-custom-select__option--disabled')) prev = prev.previousElementSibling;
          if (prev) prev.focus();
        }
        if (e.key === 'Escape' || e.key === 'Tab') {
          customSelect.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
          if (e.key === 'Tab') e.preventDefault();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!customSelect.contains(e.target)) {
        customSelect.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Native variant select ---- */
  var nativeSelect = document.getElementById('prd-variant-select');
  if (nativeSelect) {
    nativeSelect.addEventListener('change', function () {
      var variant = findVariantById(this.value);
      if (variant) applyVariant(variant);
    });
  }

  /* ---- Mobile gallery slider + pinch-to-zoom ---- */
  (function () {
    var mq        = window.matchMedia('(max-width: 700px)');
    var grid      = document.getElementById('gallery-grid');
    var counterEl = document.getElementById('mobile-gallery-counter');
    if (!grid || !counterEl) return;

    /* On mobile, move thumbnail items out of their wrapper into the grid
       so they become direct swipe slides (wrapper is hidden via CSS) */
    if (mq.matches) {
      var thumbsWrap = document.getElementById('gallery-thumbs-wrap');
      if (thumbsWrap) {
        Array.from(thumbsWrap.querySelectorAll('.gallery-item')).forEach(function (item) {
          grid.appendChild(item);
        });
      }
    }

    var items = Array.from(grid.querySelectorAll('.gallery-item--main, .gallery-item'));
    var total = items.length;
    var current = 0;

    /* Force eager loading so swiping doesn't show blanks */
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (img) img.loading = 'eager';
    });

    /* --- Pinch-to-zoom state --- */
    var _pinching   = false;
    var _startDist  = 0;
    var _startScale = 1;
    var _scale      = 1;
    var _zoomedImg  = null;
    var MAX_SCALE   = 4;

    function getTouchDist(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function resetZoom() {
      _scale    = 1;
      _pinching = false;
      if (_zoomedImg) {
        _zoomedImg.style.transform      = '';
        _zoomedImg.style.transformOrigin = '';
        _zoomedImg = null;
      }
    }

    /* --- Counter --- */
    function updateCounter() {
      var w = grid.clientWidth;
      if (!w) return;
      var prev = current;
      current = Math.min(total - 1, Math.max(0, Math.round(grid.scrollLeft / w)));
      if (prev !== current) resetZoom();
      counterEl.textContent = (current + 1) + ' / ' + total;
    }

    grid.addEventListener('scroll', updateCounter, { passive: true });
    requestAnimationFrame(updateCounter);

    /* --- Touch handlers --- */
    grid.addEventListener('touchstart', function (e) {
      if (!mq.matches || e.touches.length !== 2) return;
      e.preventDefault();
      _pinching   = true;
      _startDist  = getTouchDist(e.touches);
      _startScale = _scale;
      var idx = Math.min(total - 1, Math.max(0, Math.round(grid.scrollLeft / grid.clientWidth)));
      _zoomedImg  = items[idx] ? items[idx].querySelector('img') : null;
    }, { passive: false });

    grid.addEventListener('touchmove', function (e) {
      if (!mq.matches || !_pinching || e.touches.length < 2) return;
      e.preventDefault();
      _scale = Math.min(MAX_SCALE, Math.max(1, _startScale * (getTouchDist(e.touches) / _startDist)));
      if (_zoomedImg) {
        _zoomedImg.style.transform      = 'scale(' + _scale + ')';
        _zoomedImg.style.transformOrigin = 'center center';
      }
    }, { passive: false });

    grid.addEventListener('touchend', function (e) {
      if (!mq.matches) return;
      if (e.touches.length < 2) {
        _pinching = false;
        if (_scale < 1.05) resetZoom();
      }
    }, { passive: true });

    /* Expose for lightbox guard */
    window._prdMobileSlider = {
      isMobile: function () { return mq.matches; },
      getCurrent: function () { return current; }
    };
  })();

  /* ---- Desktop thumbnail gallery ---- */
  var desktopMq     = window.matchMedia('(min-width: 701px)');
  var mainItem      = document.querySelector('.gallery-item--main');
  var mainImg       = mainItem ? mainItem.querySelector('img') : null;
  var thumbItems    = Array.from(document.querySelectorAll('#gallery-thumbs-wrap .gallery-item'));
  var currentDesktopIdx = 0;

  function setThumb(idx) {
    var allItems = mainItem ? [mainItem].concat(thumbItems) : thumbItems;
    if (!allItems[idx]) return;
    currentDesktopIdx = idx;
    var item = allItems[idx];
    if (mainImg) {
      var src   = item.dataset.src   || mainImg.src;
      var large = item.dataset.large || src;
      mainImg.src    = src;
      mainImg.srcset = src + ' 900w, ' + large + ' 1400w';
      mainImg.alt    = item.dataset.alt || mainImg.alt;
    }
    thumbItems.forEach(function (t, j) {
      t.classList.toggle('gallery-item--thumb-active', j === idx - 1);
    });
  }

  thumbItems.forEach(function (thumb, j) {
    thumb.addEventListener('click', function () {
      if (!desktopMq.matches) return;
      setThumb(j + 1);
    });
    thumb.addEventListener('keydown', function (e) {
      if (!desktopMq.matches) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setThumb(j + 1); }
    });
  });

  /* ---- Image zoom: lens on image + large result panel to the right ---- */
  (function () {
    var ZOOM  = 2.5;
    var RES_W = 420;
    var RES_H = 420;

    var gallery  = document.querySelector('.product-gallery');
    var zoomItem = document.querySelector('.gallery-item--main');
    if (!gallery || !zoomItem) return;

    /* Lens: child of zoomItem so it overlays the image */
    var lens = document.createElement('div');
    lens.className = 'prd-zoom-lens';
    zoomItem.appendChild(lens);

    /* Result: child of product-gallery (position:relative, no overflow:hidden)
       so it can escape the clipped zoomItem and appear to the right          */
    var result = document.createElement('div');
    result.className = 'prd-zoom-result';
    gallery.appendChild(result);

    var deskMq = window.matchMedia('(min-width: 701px)');

    function getImgSrc() {
      var img = zoomItem.querySelector('img');
      return img ? (img.currentSrc || img.src) : '';
    }

    /* Returns the actual rendered rect of the image inside the container,
       accounting for object-fit: contain (letterboxing).                  */
    function getRenderedRect(containerW, containerH) {
      var img = zoomItem.querySelector('img');
      var nw  = img && img.naturalWidth  ? img.naturalWidth  : containerW;
      var nh  = img && img.naturalHeight ? img.naturalHeight : containerH;
      var scale = Math.min(containerW / nw, containerH / nh);
      var rw = nw * scale;
      var rh = nh * scale;
      return { w: rw, h: rh, x: (containerW - rw) / 2, y: (containerH - rh) / 2 };
    }

    function update(relX, relY, iw, ih, resW, resH) {
      var ri = getRenderedRect(iw, ih);

      /* Lens dimensions in rendered-image space */
      var lw = resW / ZOOM;
      var lh = resH / ZOOM;

      /* Cursor relative to actual image (strip letterbox offset) */
      var curX = relX - ri.x;
      var curY = relY - ri.y;

      /* Lens top-left clamped to image bounds */
      var lx = Math.max(0, Math.min(ri.w - lw, curX - lw / 2));
      var ly = Math.max(0, Math.min(ri.h - lh, curY - lh / 2));

      /* Draw lens in container space (add back the letterbox offset) */
      lens.style.left    = (lx + ri.x) + 'px';
      lens.style.top     = (ly + ri.y) + 'px';
      lens.style.width   = lw + 'px';
      lens.style.height  = lh + 'px';
      lens.style.display = 'block';

      /* Result background: size = rendered image × ZOOM, pos = lens origin × ZOOM */
      result.style.backgroundImage    = 'url("' + getImgSrc() + '")';
      result.style.backgroundSize     = (ri.w * ZOOM) + 'px ' + (ri.h * ZOOM) + 'px';
      result.style.backgroundPosition = (-lx * ZOOM) + 'px ' + (-ly * ZOOM) + 'px';
      result.style.display = 'block';
    }

    function hide() {
      lens.style.display   = 'none';
      result.style.display = 'none';
      zoomItem.classList.remove('is-zooming');
    }

    /* ---- Desktop: mouse hover ---- */
    zoomItem.addEventListener('mousemove', function (e) {
      if (!deskMq.matches) return;
      var r  = zoomItem.getBoundingClientRect();
      var gr = gallery.getBoundingClientRect();
      var ri = getRenderedRect(r.width, r.height);
      zoomItem.classList.add('is-zooming');
      /* Anchor result to the right edge of the *visible* image, not the container */
      result.style.left   = (r.left + ri.x + ri.w - gr.left + 8) + 'px';
      result.style.top    = (r.top  + ri.y         - gr.top)      + 'px';
      result.style.width  = RES_W + 'px';
      result.style.height = RES_H + 'px';
      update(e.clientX - r.left, e.clientY - r.top, r.width, r.height, RES_W, RES_H);
    });

    zoomItem.addEventListener('mouseleave', hide);

    /* ---- Mobile: single-finger touch-drag ---- */
    var _touching = false;

    zoomItem.addEventListener('touchstart', function (e) {
      if (deskMq.matches || e.touches.length !== 1) return;
      _touching = true;
    }, { passive: true });

    zoomItem.addEventListener('touchmove', function (e) {
      if (deskMq.matches || !_touching || e.touches.length !== 1) return;
      var t    = e.touches[0];
      var r    = zoomItem.getBoundingClientRect();
      var gr   = gallery.getBoundingClientRect();
      var relX = t.clientX - r.left;
      var relY = t.clientY - r.top;

      /* Square result overlay inside the gallery, opposite corner to finger */
      var mSize  = Math.round(Math.min(r.width, r.height) * 0.55);
      var onLeft = relX > r.width / 2;
      /* Position relative to product-gallery (offset by zoomItem's position within gallery) */
      var itemOffsetTop  = r.top  - gr.top;
      result.style.width  = mSize + 'px';
      result.style.height = mSize + 'px';
      result.style.left   = (onLeft ? 8 : r.width - mSize - 8) + 'px';
      result.style.top    = (itemOffsetTop + 8) + 'px';

      update(relX, relY, r.width, r.height, mSize, mSize);
    }, { passive: true });

    zoomItem.addEventListener('touchend',    function () { _touching = false; hide(); }, { passive: true });
    zoomItem.addEventListener('touchcancel', function () { _touching = false; hide(); }, { passive: true });

    /* Suppress iOS long-press context menu (image save/download sheet) */
    zoomItem.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  })();

  /* ---- Lightbox ---- */
  var lightbox        = document.getElementById('prd-lightbox');
  var lightboxImg     = document.getElementById('prd-lightbox-img');
  var lightboxClose   = document.getElementById('prd-lightbox-close');
  var lightboxCounter = document.getElementById('prd-lightbox-counter');
  var thumbsEl        = document.getElementById('prd-lightbox-thumbs');
  var galleryGrid     = document.getElementById('gallery-grid');
  var galleryItems    = galleryGrid
    ? Array.from(galleryGrid.querySelectorAll('.gallery-item--main, .gallery-item'))
    : [];
  var allImages       = [];
  var thumbEls        = [];
  var currentIdx      = 0;

  /* Build image list from data attributes */
  galleryItems.forEach(function (item, i) {
    var img = item.querySelector('img');
    if (!img) return;
    allImages.push({
      src:   item.dataset.src   || img.src,
      large: item.dataset.large || img.src.replace(/width=\d+/, 'width=1400'),
      alt:   item.dataset.alt   || img.alt || ''
    });
    item.addEventListener('click', function () {
      if (window._prdMobileSlider && window._prdMobileSlider.isMobile()) return;
      if (item.classList.contains('gallery-item--main')) {
        /* Main preview: open lightbox at currently displayed image */
        openLightbox(currentDesktopIdx);
      }
      /* Thumbnails: click is handled by the thumbItems loop above (setThumb) */
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (window._prdMobileSlider && window._prdMobileSlider.isMobile()) return;
        if (item.classList.contains('gallery-item--main')) {
          openLightbox(currentDesktopIdx);
        }
      }
    });
  });

  /* Build thumbnails once */
  if (thumbsEl && allImages.length) {
    allImages.forEach(function (image, i) {
      var t = document.createElement('img');
      t.src = image.src;
      t.alt = image.alt;
      t.className = 'prd-lightbox__thumb';
      t.setAttribute('role', 'button');
      t.tabIndex = 0;
      t.addEventListener('click', function () { setActive(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(i); }
      });
      thumbsEl.appendChild(t);
      thumbEls.push(t);
    });
  }

  function setActive(i) {
    currentIdx = i;
    if (lightboxImg) { lightboxImg.src = allImages[i].large; lightboxImg.alt = allImages[i].alt; }
    thumbEls.forEach(function (t, j) {
      t.classList.toggle('prd-lightbox__thumb--active', j === i);
    });
    /* Scroll thumb into view */
    if (thumbEls[i]) thumbEls[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    /* Update counter */
    if (lightboxCounter) lightboxCounter.textContent = (i + 1) + ' / ' + allImages.length;
  }

  var _lastFocus = null;

  function openLightbox(i) {
    if (!lightbox || allImages.length === 0) return;
    _lastFocus = document.activeElement;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setActive(i);
    if (lightboxClose) lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (_lastFocus) { _lastFocus.focus(); _lastFocus = null; }
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  /* ---- Lightbox touch swipe (mobile) ---- */
  var _lbMain = document.querySelector('.prd-lightbox__main');
  if (_lbMain) {
    var _touchStartX = 0;
    var _touchStartY = 0;

    _lbMain.addEventListener('touchstart', function (e) {
      _touchStartX = e.changedTouches[0].clientX;
      _touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    _lbMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - _touchStartX;
      var dy = e.changedTouches[0].clientY - _touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) {
        setActive((currentIdx + 1) % allImages.length);
      } else {
        setActive((currentIdx - 1 + allImages.length) % allImages.length);
      }
    }, { passive: true });
  }

  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeLightbox(); return; }
    if (e.key === 'ArrowUp'   || e.key === 'ArrowLeft')  setActive((currentIdx - 1 + allImages.length) % allImages.length);
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') setActive((currentIdx + 1) % allImages.length);
    if (e.key === 'Tab') {
      var focusable = Array.from(lightbox.querySelectorAll('button, [role="button"][tabindex="0"]'));
      if (focusable.length < 2) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---- Add to Cart (AJAX — no redirect) ---- */
  (function () {
    var form = document.getElementById('product-form');
    if (!form) return;

    /* Inject error message element right after the ATC row */
    var atcRow = form.querySelector('.prd-atc-row');
    var atcError = document.createElement('p');
    atcError.id = 'prd-atc-error';
    atcError.className = 'prd-atc-error';
    atcError.setAttribute('aria-live', 'polite');
    atcError.hidden = true;
    if (atcRow) atcRow.insertAdjacentElement('afterend', atcError);

    var _errorTimer = null;
    function showAtcError(msg) {
      atcError.textContent = msg;
      atcError.hidden = false;
      clearTimeout(_errorTimer);
      _errorTimer = setTimeout(function () {
        atcError.hidden = true;
      }, 6000);
    }

    function hideAtcError() {
      clearTimeout(_errorTimer);
      atcError.hidden = true;
    }

    function restoreBtn() {
      if (atcBtn) atcBtn.disabled = false;
      if (atcText) atcText.textContent = atcBtn ? (atcBtn.dataset.addText || 'Add to cart') : 'Add to cart';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (atcBtn && atcBtn.disabled) return;

      var variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;

      var qty = 1;
      var qtyEl = document.getElementById('prd-quantity');
      if (qtyEl) qty = parseInt(qtyEl.value, 10) || 1;

      hideAtcError();
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (addedItem) {
        if (window.fbq) {
          fbq('track', 'AddToCart', {
            content_ids: [String(addedItem.product_id)],
            content_type: 'product',
            value: addedItem.line_price / 100,
            currency: '{{ cart.currency.iso_code }}'
          });
        }
        if (window.clarity) { window.clarity('event', 'AddToCart'); }

        /* Update cart count bubble in the header */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* Fire event so cart drawer syncBadge can update existing badges (including clearing display:none) */
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { cart: cart } }));
            /* Update all existing badges directly */
            document.querySelectorAll('.cart-count').forEach(function (b) {
              b.textContent = cart.item_count;
              b.style.display = cart.item_count > 0 ? '' : 'none';
            });
            /* Create badge on any .cart-btn that doesn't have one yet */
            if (cart.item_count > 0) {
              document.querySelectorAll('.cart-btn').forEach(function (btn) {
                if (!btn.querySelector('.cart-count')) {
                  var counter = document.createElement('span');
                  counter.className = 'cart-count';
                  counter.setAttribute('aria-hidden', 'true');
                  counter.textContent = cart.item_count;
                  btn.insertBefore(counter, btn.firstChild);
                }
              });
            }
          });

        /* Show a brief "Added!" confirmation on the button */
        if (atcText) atcText.textContent = 'Added!';
        setTimeout(function () {
          restoreBtn();
        }, 1500);
      })
      .catch(function (err) {
        restoreBtn();
        /* 422 from Shopify when inventory limit is exceeded */
        var isInventoryError = err && (
          (err.status === 422) ||
          (typeof err.description === 'string' && /quantity|stock|inventory/i.test(err.description))
        );
        if (isInventoryError) {
          showAtcError('The maximum quantity of this item is already in your cart.');
        }
      });
    });
  })();

  /* ---- Quantity stepper ---- */
  var qtyInput = document.getElementById('prd-quantity');
  var qtyMinus = document.getElementById('prd-qty-minus');
  var qtyPlus  = document.getElementById('prd-qty-plus');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* ---- Wishlist / Favourites ---- */
  (function () {
    var fav = window.NileFavourites;
    if (!fav) return;

    /* -- Main product page heart -- */
    var wishBtn = document.getElementById('prd-btn-wishlist');
    if (wishBtn) {
      function setWishState(active) {
        var icon = wishBtn.querySelector('i');
        if (active) {
          wishBtn.classList.add('prd-btn-wishlist--active');
          wishBtn.setAttribute('aria-label', wishBtn.dataset.removeLabel || 'Remove from favourites');
          if (icon) { icon.className = 'fa-solid fa-heart'; }
        } else {
          wishBtn.classList.remove('prd-btn-wishlist--active');
          wishBtn.setAttribute('aria-label', wishBtn.dataset.addLabel || 'Add to favourites');
          if (icon) { icon.className = 'fa-regular fa-heart'; }
        }
      }

      setWishState(fav.has(wishBtn.dataset.favId));

      wishBtn.addEventListener('click', function () {
        var product = {
          id:    wishBtn.dataset.favId,
          title: wishBtn.dataset.favTitle,
          url:   wishBtn.dataset.favUrl,
          image: wishBtn.dataset.favImage,
          price: wishBtn.dataset.favPrice
        };
        var added = fav.toggle(product);
        setWishState(added);

        if (added) {
          var rect  = wishBtn.getBoundingClientRect();
          var heart = document.createElement('span');
          heart.className = 'prd-floating-heart';
          heart.setAttribute('aria-hidden', 'true');
          heart.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
          heart.style.left = (rect.left + rect.width / 2 - 11) + 'px';
          heart.style.top  = (rect.top - 4) + 'px';
          document.body.appendChild(heart);
          heart.addEventListener('animationend', function () { heart.remove(); });
        }
      });
    }

    /* -- Similar product card hearts -- */
    var simWishes = document.querySelectorAll('.sim-card__wish[data-fav-id]');
    Array.prototype.forEach.call(simWishes, function (btn) {
      function setSimState(active) {
        var icon = btn.querySelector('i');
        if (active) {
          btn.classList.add('sim-card__wish--active');
          btn.setAttribute('aria-label', 'Remove from favourites');
          if (icon) { icon.className = 'fa-solid fa-heart'; }
        } else {
          btn.classList.remove('sim-card__wish--active');
          btn.setAttribute('aria-label', 'Add to favourites');
          if (icon) { icon.className = 'fa-regular fa-heart'; }
        }
      }

      setSimState(fav.has(btn.dataset.favId));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var product = {
          id:    btn.dataset.favId,
          title: btn.dataset.favTitle,
          url:   btn.dataset.favUrl,
          image: btn.dataset.favImage,
          price: btn.dataset.favPrice
        };
        var added = fav.toggle(product);
        setSimState(added);
        if (added) {
          var rect  = btn.getBoundingClientRect();
          var heart = document.createElement('span');
          heart.className = 'prd-floating-heart';
          heart.setAttribute('aria-hidden', 'true');
          heart.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
          heart.style.left = (rect.left + rect.width / 2 - 11) + 'px';
          heart.style.top  = (rect.top - 4) + 'px';
          document.body.appendChild(heart);
          heart.addEventListener('animationend', function () { heart.remove(); });
        }
      });
    });
  })();

  /* ---- Recently Viewed ---- */
  (function () {
    var RV_KEY  = 'nile_rv_v1';
    var RV_MAX  = 20;
    var RV_SHOW = 8;

    if (!productData) return;
    var currentId = productData.id;

    function getRV() {
      try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
    }
    function saveRV(arr) {
      try { localStorage.setItem(RV_KEY, JSON.stringify(arr)); } catch (e) {}
    }
    /* Resize Shopify CDN image URL (e.g. image.jpg → image_400x.jpg) */
    function rvImgUrl(src, width) {
      if (!src) return '';
      return src.replace(/(\.[^.?]+)(\?.*)?$/, function (_, ext, qs) {
        return '_' + width + 'x' + ext + (qs || '');
      });
    }

    /* Save current product */
    var rv = getRV();
    rv = rv.filter(function (p) { return p.id !== currentId; });
    var rvCompareAt = productData.compare_at_price && productData.compare_at_price > productData.price
      ? productData.compare_at_price : 0;
    rv.unshift({
      id:             currentId,
      title:          productData.title,
      url:            '/products/' + productData.handle,
      image:          rvImgUrl(productData.featured_image, 400),
      price:          formatMoney(productData.price),
      compareAtPrice: rvCompareAt ? formatMoney(rvCompareAt) : null,
      discountPct:    rvCompareAt ? Math.round((rvCompareAt - productData.price) / rvCompareAt * 100) : 0
    });
    if (rv.length > RV_MAX) rv = rv.slice(0, RV_MAX);
    saveRV(rv);

    /* Render recently viewed section */
    var toShow = getRV().filter(function (p) { return p.id !== currentId; }).slice(0, RV_SHOW);
    if (toShow.length === 0) return;

    var section = document.getElementById('rv-prods');
    if (!section) return;
    var track = section.querySelector('.rv-prods__track');
    if (!track) return;

    toShow.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'sim-card';
      a.href = p.url;
      var imgHtml = p.image
        ? '<img class="sim-card__img" src="' + p.image + '" alt="' + (p.title || '').replace(/</g, '&lt;').replace(/"/g, '&quot;') + '" loading="lazy">'
        : '';
      a.innerHTML =
        '<div class="sim-card__img-wrap">' + imgHtml + '</div>' +
        '<div class="sim-card__info">' +
          '<p class="sim-card__name"></p>' +
          '<div class="sim-card__price-row">' +
            (p.compareAtPrice ? '<s class="sim-card__price-compare"></s>' : '') +
            '<span class="sim-card__price' + (p.compareAtPrice ? ' sim-card__price--sale' : '') + '"></span>' +
          '</div>' +
        '</div>';

      /* Build heart button safely via DOM (avoids HTML injection from price/title) */
      var wishBtn = document.createElement('button');
      wishBtn.className = 'sim-card__wish';
      wishBtn.type = 'button';
      wishBtn.setAttribute('aria-label', 'Add to favourites');
      wishBtn.setAttribute('onclick', 'event.preventDefault()');
      wishBtn.dataset.favId    = String(p.id);
      wishBtn.dataset.favTitle = p.title || '';
      wishBtn.dataset.favUrl   = p.url || '';
      wishBtn.dataset.favImage = p.image || '';
      wishBtn.dataset.favPrice = p.price || '';
      var heartIcon = document.createElement('i');
      heartIcon.className = 'fa-regular fa-heart';
      heartIcon.setAttribute('aria-hidden', 'true');
      wishBtn.appendChild(heartIcon);
      a.querySelector('.sim-card__img-wrap').appendChild(wishBtn);

      var rvTitle = p.title || '';
      if (rvTitle.length > 28) rvTitle = rvTitle.slice(0, 25) + '...';
      a.querySelector('.sim-card__name').textContent  = rvTitle;
      a.querySelector('.sim-card__price').textContent = p.price || '';
      if (p.compareAtPrice) {
        a.querySelector('.sim-card__price-compare').textContent = p.compareAtPrice;
      }
      if (p.discountPct > 0) {
        var badge = document.createElement('span');
        badge.className = 'sim-card__badge sim-card__badge--sale';
        badge.textContent = '-' + p.discountPct + '%';
        a.querySelector('.sim-card__img-wrap').appendChild(badge);
      }

      track.appendChild(a);
    });

    /* Wire up wishlist for RV cards */
    function wireRvFav() {
      var fav = window.NileFavourites;
      if (!fav) return;
      var rvWishes = track.querySelectorAll('.sim-card__wish[data-fav-id]');
      Array.prototype.forEach.call(rvWishes, function (btn) {
        if (btn.dataset.favWired) return;
        btn.dataset.favWired = '1';
        function setRvState(active) {
          var icon = btn.querySelector('i');
          if (active) {
            btn.classList.add('sim-card__wish--active');
            btn.setAttribute('aria-label', 'Remove from favourites');
            if (icon) { icon.className = 'fa-solid fa-heart'; }
          } else {
            btn.classList.remove('sim-card__wish--active');
            btn.setAttribute('aria-label', 'Add to favourites');
            if (icon) { icon.className = 'fa-regular fa-heart'; }
          }
        }
        setRvState(fav.has(btn.dataset.favId));
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var product = {
            id:    btn.dataset.favId,
            title: btn.dataset.favTitle,
            url:   btn.dataset.favUrl,
            image: btn.dataset.favImage,
            price: btn.dataset.favPrice
          };
          var added = fav.toggle(product);
          setRvState(added);
          if (added) {
            var rect  = btn.getBoundingClientRect();
            var heart = document.createElement('span');
            heart.className = 'prd-floating-heart';
            heart.setAttribute('aria-hidden', 'true');
            heart.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
            heart.style.left = (rect.left + rect.width / 2 - 11) + 'px';
            heart.style.top  = (rect.top - 4) + 'px';
            document.body.appendChild(heart);
            heart.addEventListener('animationend', function () { heart.remove(); });
          }
        });
      });
    }
    if (window.NileFavourites) {
      wireRvFav();
    } else {
      document.addEventListener('nile:fav-ready', wireRvFav, { once: true });
      window.addEventListener('load', wireRvFav);
    }

    section.style.display = '';
  })();

  /* ---- Watch Video Modal ---- */
  (function () {
    var btn     = document.getElementById('prd-watch-video-btn');
    var modal   = document.getElementById('prd-video-modal');
    var closeBtn = document.getElementById('prd-video-modal-close');
    var backdrop = document.getElementById('prd-video-modal-backdrop');
    var player  = document.getElementById('prd-video-modal-player');

    if (!btn || !modal) return;

    function getEmbedUrl(url) {
      // YouTube — support watch, short, and embed URLs
      var yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&modestbranding=1';
      // Vimeo
      var vi = url.match(/vimeo\.com\/(\d+)/);
      if (vi) return 'https://player.vimeo.com/video/' + vi[1] + '?autoplay=1&color=c4ad8a&title=0&byline=0&portrait=0';
      return null;
    }

    function buildPlayer(videoUrl) {
      player.innerHTML = '';
      var embedUrl = getEmbedUrl(videoUrl);
      if (embedUrl) {
        // Wrap iframe in 16:9 aspect-ratio container
        var wrap = document.createElement('div');
        wrap.className = 'prd-video-modal__iframe-wrap';
        var iframe = document.createElement('iframe');
        iframe.className = 'prd-video-modal__iframe';
        iframe.src = embedUrl;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        wrap.appendChild(iframe);
        player.appendChild(wrap);
      } else {
        // Native video: no wrapper, natural dimensions + visible controls
        var video = document.createElement('video');
        video.className = 'prd-video-modal__video';
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        player.appendChild(video);
        video.play().catch(function () {});
      }
    }

    function destroyPlayer() {
      var video = player.querySelector('.prd-video-modal__video');
      var iframe = player.querySelector('.prd-video-modal__iframe');
      if (video) { video.pause(); video.src = ''; }
      if (iframe) { iframe.src = ''; } // stops embed playback
      player.innerHTML = '';
    }

    function openModal() {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      // Double rAF so browser paints display:flex before opacity transition
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
          buildPlayer(btn.dataset.videoUrl);
        });
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      destroyPlayer();
      modal.addEventListener('transitionend', function onDone() {
        modal.setAttribute('hidden', '');
        modal.removeEventListener('transitionend', onDone);
      }, { once: true });
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      openModal();
    });
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();

  /* ---- Accordion: one open at a time ---- */
  (function () {
    var accordions = document.querySelectorAll('.prd-accordion');
    accordions.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          accordions.forEach(function (other) {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  })();

})();

  } catch(e) { console.error(e); }
})();
})();
